export default {
  abi: [
    {
      inputs: [
        {
          internalType: 'uint256',
          name: 'maxTransactions',
          type: 'uint256',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'constructor',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'previousOwner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Paused',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'amt',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'total',
          type: 'uint256',
        },
      ],
      name: 'TotalTransactionsUpdated',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Unpaused',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'verificationCode',
          type: 'uint256',
        },
      ],
      name: 'VerificationSubmitted',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
      ],
      name: 'WalletAdded',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
      ],
      name: 'WalletPermissionsRevoked',
      type: 'event',
    },
    {
      inputs: [
        {
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
      ],
      name: 'accountStatus',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
        {
          internalType: 'uint256',
          name: 'amt',
          type: 'uint256',
        },
      ],
      name: 'acctUnderLimit',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
      ],
      name: 'addVerifiedWallet',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
      ],
      name: 'getAccountTransactionsTotal',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'getAccountUserView',
      outputs: [
        {
          components: [
            {
              internalType: 'uint256',
              name: 'status',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'currentTotalTransactions',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'maxTransactions',
              type: 'uint256',
            },
          ],
          internalType: 'struct Verification.AccountUserView',
          name: 'accountUserView',
          type: 'tuple',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'getWalletAccountId',
      outputs: [
        {
          internalType: 'string',
          name: '',
          type: 'string',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'getWalletTransactionsTotal',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'amt',
          type: 'uint256',
        },
      ],
      name: 'isValid',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paused',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'renounceOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
      ],
      name: 'revokeAccountPermissions',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'revokeWalletPermissions',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
        {
          internalType: 'uint256',
          name: 'maxTransactions',
          type: 'uint256',
        },
      ],
      name: 'setTransactionLimits',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
        {
          internalType: 'uint256',
          name: 'verificationCode',
          type: 'uint256',
        },
      ],
      name: 'submitVerification',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'amt',
          type: 'uint256',
        },
      ],
      name: 'updateTotalTransactions',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'string',
          name: 'accountId',
          type: 'string',
        },
        {
          internalType: 'uint256',
          name: 'amt',
          type: 'uint256',
        },
      ],
      name: 'updateTransactionCount',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'walletStatus',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
  ],
  bytecode: {
    object:
      '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',
    sourceMap:
      '199:5312:47:-:0;;;698:1;667:32;;743:1;705:39;;776:1;750:27;;1078:88;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;936:32:19;719:10:32;936:18:19;:32::i;:::-;1006:5:24;996:15;;-1:-1:-1;;;;996:15:24;;;1125:16:47;:34;199:5312;;2426:187:19;2499:16;2518:6;;-1:-1:-1;;;;;2534:17:19;;;-1:-1:-1;;;;;;2534:17:19;;;;;;2566:40;;2518:6;;;;;;;2566:40;;2499:16;2566:40;2489:124;2426:187;:::o;14:184:50:-;84:6;137:2;125:9;116:7;112:23;108:32;105:52;;;153:1;150;143:12;105:52;-1:-1:-1;176:16:50;;14:184;-1:-1:-1;14:184:50:o;:::-;199:5312:47;;;;;;',
    linkReferences: {},
  },
  deployedBytecode: {
    object:
      '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',
    sourceMap:
      '199:5312:47:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1494:368;;;;;;:::i;:::-;;:::i;:::-;;4268:177;;;;;;:::i;:::-;;:::i;4072:190::-;;;;;;:::i;:::-;;:::i;1868:196::-;;;;;;:::i;:::-;;:::i;2798:165::-;;;;;;:::i;:::-;;:::i;:::-;;;2181:25:50;;;2169:2;2154:18;2798:165:47;;;;;;;;4451:123;;;;;;:::i;:::-;;:::i;2969:496::-;;;;;;:::i;:::-;;:::i;:::-;;;2641:14:50;;2634:22;2616:41;;2604:2;2589:18;2969:496:47;2476:187:50;1615:84:24;1662:4;1685:7;-1:-1:-1;;;1685:7:24;;;;1615:84;;1824:101:19;;;:::i;1172:316:47:-;;;;;;:::i;:::-;;:::i;4580:143::-;;;;;;:::i;:::-;;:::i;2359:252::-;;;;;;:::i;:::-;;:::i;1201:85:19:-;1247:7;1273:6;1201:85;;-1:-1:-1;;;;;1273:6:19;;;3141:51:50;;3129:2;3114:18;1201:85:19;2995:203:50;3471:595:47;;;;;;:::i;:::-;;:::i;2617:175::-;;;;;;:::i;:::-;;:::i;4864:505::-;;;;;;:::i;:::-;;:::i;:::-;;;;3435:13:50;;3417:32;;3505:4;3493:17;;;3487:24;3465:20;;;3458:54;3556:17;;;3550:24;3528:20;;;3521:54;3405:2;3390:18;4864:505:47;3203:378:50;5375:134:47;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;2074:198:19:-;;;;;;:::i;:::-;;:::i;2070:283:47:-;;;;;;:::i;:::-;;:::i;1494:368::-;1094:13:19;:11;:13::i;:::-;1650:1:47::1;1611:9;1621;1611:20;;;;;;:::i;:::-;::::0;;;::::1;::::0;;;;;;::::1;::::0;;;;;-1:-1:-1;;;;;1611:36:47;::::1;:28;:36:::0;;;;;;:40;;;;1700:16:::1;::::0;;1661:9:::1;::::0;:20:::1;::::0;1671:9;;1661:20:::1;:::i;:::-;;;;;;;;;;;;;:36;;:55;;;;1756:15;;1726:9;1736;1726:20;;;;;;:::i;:::-;::::0;;;::::1;::::0;;::::1;::::0;;;;;;;;:27:::1;;:45:::0;;;;-1:-1:-1;;;;;1781:16:47;::::1;;::::0;;;:8:::1;:16:::0;;;;:28:::1;1800:9:::0;1781:16;:28:::1;:::i;:::-;;1837:6;-1:-1:-1::0;;;;;1825:30:47::1;;1845:9;1825:30;;;;;;:::i;:::-;;;;;;;;1494:368:::0;;:::o;4268:177::-;1094:13:19;:11;:13::i;:::-;4435:3:47::1;4387:9;4397;4387:20;;;;;;:::i;:::-;::::0;;;::::1;::::0;;;;;::::1;::::0;;;:45:::1;;:51:::0;-1:-1:-1;;4268:177:47:o;4072:190::-;1094:13:19;:11;:13::i;:::-;4240:15:47::1;4201:9;4211;4201:20;;;;;;:::i;:::-;::::0;;;::::1;::::0;;;;;::::1;::::0;;;:36:::1;;:54:::0;-1:-1:-1;;4072:190:47:o;1868:196::-;1094:13:19;:11;:13::i;:::-;-1:-1:-1;;;;;1954:16:47;::::1;1990:1;1954:16:::0;;;:8:::1;:16;::::0;;;;;1944:27;;:9:::1;::::0;:27:::1;::::0;::::1;:::i;:::-;::::0;;;::::1;::::0;;;;;;::::1;::::0;;;;;-1:-1:-1;;;;;1944:43:47;::::1;:35;:43:::0;;;;;;;;;:47;;;;2040:8:::1;:16:::0;;;;2007:50:::1;::::0;::::1;::::0;2040:16;2007:50:::1;:::i;:::-;;;;;;;;1868:196:::0;:::o;2798:165::-;-1:-1:-1;;;;;2939:16:47;;2885:7;2939:16;;;:8;:16;;;;;2911:45;;;;2939:16;2911:45;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:27;:45::i;:::-;2904:52;2798:165;-1:-1:-1;;2798:165:47:o;4451:123::-;-1:-1:-1;;;;;4550:16:47;;4510:7;4550:16;;;:8;:16;;;;;4536:31;;;;4550:16;4536:31;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:13;:31::i;2969:496::-;-1:-1:-1;;;;;3083:16:47;;3036:4;3083:16;;;:8;:16;;;;;;3073:27;;:9;;:27;;;:::i;:::-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;3073:43:47;;:35;:43;;;;;;;;:48;;3052:132;;;;-1:-1:-1;;;3052:132:47;;9272:2:50;3052:132:47;;;9254:21:50;9311:2;9291:18;;;9284:30;9350:34;9330:18;;;9323:62;-1:-1:-1;;;9401:18:50;;;9394:35;9446:19;;3052:132:47;;;;;;;;;3250:20;;-1:-1:-1;;;;;3229:16:47;;;;;;:8;:16;;;;;3215:31;;;;3229:16;3215:31;;;:::i;:::-;:55;3194:122;;;;-1:-1:-1;;;3194:122:47;;9678:2:50;3194:122:47;;;9660:21:50;9717:2;9697:18;;;9690:30;-1:-1:-1;;;9736:18:50;;;9729:50;9796:18;;3194:122:47;9476:344:50;3194:122:47;-1:-1:-1;;;;;3362:16:47;;;;;;:8;:16;;;;;3347:37;;;;3362:16;3347:37;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3380:3;3347:14;:37::i;:::-;3326:110;;;;-1:-1:-1;;;3326:110:47;;10027:2:50;3326:110:47;;;10009:21:50;10066:2;10046:18;;;10039:30;10105:28;10085:18;;;10078:56;10151:18;;3326:110:47;9825:350:50;3326:110:47;-1:-1:-1;3454:4:47;2969:496;;;;:::o;1824:101:19:-;1094:13;:11;:13::i;:::-;1888:30:::1;1915:1;1888:18;:30::i;:::-;1824:101::o:0;1172:316:47:-;1239:19:24;:17;:19::i;:::-;1334:27:47::1;;1304:9;1314;1304:20;;;;;;:::i;:::-;::::0;;;::::1;::::0;;::::1;::::0;;;;;;;;:27:::1;;:57:::0;;;;1380:10:::1;1371:20;::::0;;;:8:::1;:20:::0;;;;:32:::1;1394:9:::0;1371:20;:32:::1;:::i;:::-;;1441:10;-1:-1:-1::0;;;;;1419:62:47::1;;1453:9;1464:16;1419:62;;;;;;;:::i;4580:143::-:0;4663:7;4689:9;4699;4689:20;;;;;;:::i;:::-;;;;;;;;;;;;;:27;;;4682:34;;4580:143;;;:::o;2359:252::-;2464:4;2568:9;2578;2568:20;;;;;;:::i;:::-;;;;;;;;;;;;;:36;;;2548:3;2500:9;2510;2500:20;;;;;;:::i;:::-;;;;;;;;;;;;;:45;;;:51;;;;:::i;:::-;2499:105;;;2359:252;-1:-1:-1;;;2359:252:47:o;3471:595::-;-1:-1:-1;;;;;3827:16:47;;;;;;:8;:16;;;;;;;3817:27;;3873:3;;3817:9;;:27;;3827:16;3817:27;:::i;:::-;;;;;;;;;;;;;:52;;;:59;;;;;;;:::i;:::-;;;;-1:-1:-1;;;;;;;3892:167:47;;3950:16;;;;:8;:16;;;;;;;3997:27;;3892:167;;3950:16;3980:3;;3997:9;;:27;;3950:16;;3997:27;:::i;:::-;;;;;;;;;;;;;;:52;;;3892:167;;;;;:::i;2617:175::-;2714:7;2740:9;2750;2740:20;;;;;;:::i;:::-;;;;;;;;;;;;;:45;;;2733:52;;2617:175;;;:::o;4864:505::-;4943:38;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;4943:38:47;-1:-1:-1;;;;;5019:16:47;;4993:23;5019:16;;;:8;:16;;;;;4993:42;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5045:31;5079:9;5089;5079:20;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;5128:201;;;;;5166:18;;;;5128:201;;5224:36;;;;5128:201;;;;;;;5291:27;;;5128:201;;;;5079:20;4864:505;-1:-1:-1;;;;4864:505:47:o;5375:134::-;-1:-1:-1;;;;;5486:16:47;;;;;;:8;:16;;;;;5479:23;;5454:13;;5486:16;5479:23;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5375:134;;;:::o;2074:198:19:-;1094:13;:11;:13::i;:::-;-1:-1:-1;;;;;2162:22:19;::::1;2154:73;;;::::0;-1:-1:-1;;;2154:73:19;;11277:2:50;2154:73:19::1;::::0;::::1;11259:21:50::0;11316:2;11296:18;;;11289:30;11355:34;11335:18;;;11328:62;-1:-1:-1;;;11406:18:50;;;11399:36;11452:19;;2154:73:19::1;11075:402:50::0;2154:73:19::1;2237:28;2256:8;2237:18;:28::i;:::-;2074:198:::0;:::o;2070:283:47:-;1094:13:19;:11;:13::i;:::-;2178:9:47::1;2188;2178:20;;;;;;:::i;:::-;;;;;;;;;;;;;:27;;;2209:1;2178:32:::0;2170:62:::1;;;::::0;-1:-1:-1;;;2170:62:47;;11684:2:50;2170:62:47::1;::::0;::::1;11666:21:50::0;11723:2;11703:18;;;11696:30;-1:-1:-1;;;11742:18:50;;;11735:47;11799:18;;2170:62:47::1;11482:341:50::0;2170:62:47::1;2345:1;2315:9;2325;2315:20;;;;;;:::i;:::-;::::0;;;::::1;::::0;;;;;::::1;::::0;;;:27:::1;;:31:::0;-1:-1:-1;2070:283:47:o;1359:130:19:-;1247:7;1273:6;-1:-1:-1;;;;;1273:6:19;719:10:32;1422:23:19;1414:68;;;;-1:-1:-1;;;1414:68:19;;12030:2:50;1414:68:19;;;12012:21:50;;;12049:18;;;12042:30;12108:34;12088:18;;;12081:62;12160:18;;1414:68:19;11828:356:50;2426:187:19;2499:16;2518:6;;-1:-1:-1;;;;;2534:17:19;;;-1:-1:-1;;;;;;2534:17:19;;;;;;2566:40;;2518:6;;;;;;;2566:40;;2499:16;2566:40;2489:124;2426:187;:::o;1767:106:24:-;1662:4;1685:7;-1:-1:-1;;;1685:7:24;;;;1836:9;1828:38;;;;-1:-1:-1;;;1828:38:24;;12391:2:50;1828:38:24;;;12373:21:50;12430:2;12410:18;;;12403:30;-1:-1:-1;;;12449:18:50;;;12442:46;12505:18;;1828:38:24;12189:340:50;14:173;82:20;;-1:-1:-1;;;;;131:31:50;;121:42;;111:70;;177:1;174;167:12;111:70;14:173;;;:::o;192:127::-;253:10;248:3;244:20;241:1;234:31;284:4;281:1;274:15;308:4;305:1;298:15;324:719;367:5;420:3;413:4;405:6;401:17;397:27;387:55;;438:1;435;428:12;387:55;474:6;461:20;500:18;537:2;533;530:10;527:36;;;543:18;;:::i;:::-;618:2;612:9;586:2;672:13;;-1:-1:-1;;668:22:50;;;692:2;664:31;660:40;648:53;;;716:18;;;736:22;;;713:46;710:72;;;762:18;;:::i;:::-;802:10;798:2;791:22;837:2;829:6;822:18;883:3;876:4;871:2;863:6;859:15;855:26;852:35;849:55;;;900:1;897;890:12;849:55;964:2;957:4;949:6;945:17;938:4;930:6;926:17;913:54;1011:1;1004:4;999:2;991:6;987:15;983:26;976:37;1031:6;1022:15;;;;;;324:719;;;;:::o;1048:396::-;1126:6;1134;1187:2;1175:9;1166:7;1162:23;1158:32;1155:52;;;1203:1;1200;1193:12;1155:52;1226:29;1245:9;1226:29;:::i;:::-;1216:39;;1306:2;1295:9;1291:18;1278:32;1333:18;1325:6;1322:30;1319:50;;;1365:1;1362;1355:12;1319:50;1388;1430:7;1421:6;1410:9;1406:22;1388:50;:::i;:::-;1378:60;;;1048:396;;;;;:::o;1449:390::-;1527:6;1535;1588:2;1576:9;1567:7;1563:23;1559:32;1556:52;;;1604:1;1601;1594:12;1556:52;1644:9;1631:23;1677:18;1669:6;1666:30;1663:50;;;1709:1;1706;1699:12;1663:50;1732;1774:7;1765:6;1754:9;1750:22;1732:50;:::i;:::-;1722:60;1829:2;1814:18;;;;1801:32;;-1:-1:-1;;;;1449:390:50:o;1844:186::-;1903:6;1956:2;1944:9;1935:7;1931:23;1927:32;1924:52;;;1972:1;1969;1962:12;1924:52;1995:29;2014:9;1995:29;:::i;:::-;1985:39;1844:186;-1:-1:-1;;;1844:186:50:o;2217:254::-;2285:6;2293;2346:2;2334:9;2325:7;2321:23;2317:32;2314:52;;;2362:1;2359;2352:12;2314:52;2385:29;2404:9;2385:29;:::i;:::-;2375:39;2461:2;2446:18;;;;2433:32;;-1:-1:-1;;;2217:254:50:o;2668:322::-;2737:6;2790:2;2778:9;2769:7;2765:23;2761:32;2758:52;;;2806:1;2803;2796:12;2758:52;2846:9;2833:23;2879:18;2871:6;2868:30;2865:50;;;2911:1;2908;2901:12;2865:50;2934;2976:7;2967:6;2956:9;2952:22;2934:50;:::i;:::-;2924:60;2668:322;-1:-1:-1;;;;2668:322:50:o;3586:250::-;3671:1;3681:113;3695:6;3692:1;3689:13;3681:113;;;3771:11;;;3765:18;3752:11;;;3745:39;3717:2;3710:10;3681:113;;;-1:-1:-1;;3828:1:50;3810:16;;3803:27;3586:250::o;3841:271::-;3883:3;3921:5;3915:12;3948:6;3943:3;3936:19;3964:76;4033:6;4026:4;4021:3;4017:14;4010:4;4003:5;3999:16;3964:76;:::i;:::-;4094:2;4073:15;-1:-1:-1;;4069:29:50;4060:39;;;;4101:4;4056:50;;3841:271;-1:-1:-1;;3841:271:50:o;4117:220::-;4266:2;4255:9;4248:21;4229:4;4286:45;4327:2;4316:9;4312:18;4304:6;4286:45;:::i;4342:289::-;4473:3;4511:6;4505:13;4527:66;4586:6;4581:3;4574:4;4566:6;4562:17;4527:66;:::i;:::-;4609:16;;;;;4342:289;-1:-1:-1;;4342:289:50:o;4636:380::-;4715:1;4711:12;;;;4758;;;4779:61;;4833:4;4825:6;4821:17;4811:27;;4779:61;4886:2;4878:6;4875:14;4855:18;4852:38;4849:161;;4932:10;4927:3;4923:20;4920:1;4913:31;4967:4;4964:1;4957:15;4995:4;4992:1;4985:15;4849:161;;4636:380;;;:::o;5147:543::-;5249:2;5244:3;5241:11;5238:446;;;5285:1;5309:5;5306:1;5299:16;5353:4;5350:1;5340:18;5423:2;5411:10;5407:19;5404:1;5400:27;5394:4;5390:38;5459:4;5447:10;5444:20;5441:47;;;-1:-1:-1;5482:4:50;5441:47;5537:2;5532:3;5528:12;5525:1;5521:20;5515:4;5511:31;5501:41;;5592:82;5610:2;5603:5;5600:13;5592:82;;;5655:17;;;5636:1;5625:13;5592:82;;;5596:3;;;5238:446;5147:543;;;:::o;5866:1345::-;5992:3;5986:10;6019:18;6011:6;6008:30;6005:56;;;6041:18;;:::i;:::-;6070:97;6160:6;6120:38;6152:4;6146:11;6120:38;:::i;:::-;6114:4;6070:97;:::i;:::-;6222:4;;6279:2;6268:14;;6296:1;6291:663;;;;6998:1;7015:6;7012:89;;;-1:-1:-1;7067:19:50;;;7061:26;7012:89;-1:-1:-1;;5823:1:50;5819:11;;;5815:24;5811:29;5801:40;5847:1;5843:11;;;5798:57;7114:81;;6261:944;;6291:663;5094:1;5087:14;;;5131:4;5118:18;;-1:-1:-1;;6327:20:50;;;6445:236;6459:7;6456:1;6453:14;6445:236;;;6548:19;;;6542:26;6527:42;;6640:27;;;;6608:1;6596:14;;;;6475:19;;6445:236;;;6449:3;6709:6;6700:7;6697:19;6694:201;;;6770:19;;;6764:26;-1:-1:-1;;6853:1:50;6849:14;;;6865:3;6845:24;6841:37;6837:42;6822:58;6807:74;;6694:201;-1:-1:-1;;;;;6941:1:50;6925:14;;;6921:22;6908:36;;-1:-1:-1;5866:1345:50:o;7216:843::-;7344:3;7373:1;7406:6;7400:13;7436:36;7462:9;7436:36;:::i;:::-;7491:1;7508:17;;;7534:133;;;;7681:1;7676:358;;;;7501:533;;7534:133;-1:-1:-1;;7567:24:50;;7555:37;;7640:14;;7633:22;7621:35;;7612:45;;;-1:-1:-1;7534:133:50;;7676:358;7707:6;7704:1;7697:17;7737:4;7782;7779:1;7769:18;7809:1;7823:165;7837:6;7834:1;7831:13;7823:165;;;7915:14;;7902:11;;;7895:35;7958:16;;;;7852:10;;7823:165;;;7827:3;;;8017:6;8012:3;8008:16;8001:23;;7501:533;-1:-1:-1;8050:3:50;;7216:843;-1:-1:-1;;;;;;7216:843:50:o;8064:771::-;8114:3;8155:5;8149:12;8184:36;8210:9;8184:36;:::i;:::-;8229:19;;;8267:4;8290:1;8307:17;;;8333:146;;;;8493:1;8488:341;;;;8300:529;;8333:146;-1:-1:-1;;8375:24:50;;8361:12;;;8354:46;8447:14;;8440:22;8437:1;8433:30;8424:40;;8420:49;;;-1:-1:-1;8333:146:50;;8488:341;8519:5;8516:1;8509:16;8566:2;8563:1;8553:16;8591:1;8605:174;8619:6;8616:1;8613:13;8605:174;;;8706:14;;8688:11;;;8684:20;;8677:44;8749:16;;;;8634:10;;8605:174;;;8803:11;;8799:20;;;-1:-1:-1;;8300:529:50;;;;;;8064:771;;;;:::o;8840:225::-;8986:2;8975:9;8968:21;8949:4;9006:53;9055:2;9044:9;9040:18;9032:6;9006:53;:::i;10180:291::-;10357:2;10346:9;10339:21;10320:4;10377:45;10418:2;10407:9;10403:18;10395:6;10377:45;:::i;:::-;10369:53;;10458:6;10453:2;10442:9;10438:18;10431:34;10180:291;;;;;:::o;10476:222::-;10541:9;;;10562:10;;;10559:133;;;10614:10;10609:3;10605:20;10602:1;10595:31;10649:4;10646:1;10639:15;10677:4;10674:1;10667:15;10703:367;10905:2;10894:9;10887:21;10868:4;10925:53;10974:2;10963:9;10959:18;10951:6;10925:53;:::i;:::-;11009:2;10994:18;;10987:34;;;;-1:-1:-1;11052:2:50;11037:18;11030:34;10917:61;10703:367;-1:-1:-1;10703:367:50:o',
    linkReferences: {},
  },
  methodIdentifiers: {
    'accountStatus(string)': '7fcbe329',
    'acctUnderLimit(string,uint256)': '8297822c',
    'addVerifiedWallet(address,string)': '16d13df3',
    'getAccountTransactionsTotal(string)': 'a95608a9',
    'getAccountUserView(address)': 'adeb320a',
    'getWalletAccountId(address)': 'd59ee5a9',
    'getWalletTransactionsTotal(address)': '4bb63e10',
    'isValid(address,uint256)': '59647984',
    'owner()': '8da5cb5b',
    'paused()': '5c975abb',
    'renounceOwnership()': '715018a6',
    'revokeAccountPermissions(string)': 'f5d68652',
    'revokeWalletPermissions(address)': '42599ee8',
    'setTransactionLimits(string,uint256)': '34aa97da',
    'submitVerification(string,uint256)': '74cbf076',
    'transferOwnership(address)': 'f2fde38b',
    'updateTotalTransactions(address,uint256)': '98368b25',
    'updateTransactionCount(string,uint256)': '348a5532',
    'walletStatus(address)': '4d6d0af8',
  },
  rawMetadata:
    '{"compiler":{"version":"0.8.23+commit.f704f362"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"uint256","name":"maxTransactions","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"},{"indexed":false,"internalType":"string","name":"accountId","type":"string"},{"indexed":false,"internalType":"uint256","name":"amt","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"total","type":"uint256"}],"name":"TotalTransactionsUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"},{"indexed":false,"internalType":"string","name":"accountId","type":"string"},{"indexed":false,"internalType":"uint256","name":"verificationCode","type":"uint256"}],"name":"VerificationSubmitted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"},{"indexed":false,"internalType":"string","name":"accountId","type":"string"}],"name":"WalletAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"},{"indexed":false,"internalType":"string","name":"accountId","type":"string"}],"name":"WalletPermissionsRevoked","type":"event"},{"inputs":[{"internalType":"string","name":"accountId","type":"string"}],"name":"accountStatus","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"accountId","type":"string"},{"internalType":"uint256","name":"amt","type":"uint256"}],"name":"acctUnderLimit","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"string","name":"accountId","type":"string"}],"name":"addVerifiedWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"accountId","type":"string"}],"name":"getAccountTransactionsTotal","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"getAccountUserView","outputs":[{"components":[{"internalType":"uint256","name":"status","type":"uint256"},{"internalType":"uint256","name":"currentTotalTransactions","type":"uint256"},{"internalType":"uint256","name":"maxTransactions","type":"uint256"}],"internalType":"struct Verification.AccountUserView","name":"accountUserView","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"getWalletAccountId","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"getWalletTransactionsTotal","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"uint256","name":"amt","type":"uint256"}],"name":"isValid","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"accountId","type":"string"}],"name":"revokeAccountPermissions","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"revokeWalletPermissions","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"accountId","type":"string"},{"internalType":"uint256","name":"maxTransactions","type":"uint256"}],"name":"setTransactionLimits","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"accountId","type":"string"},{"internalType":"uint256","name":"verificationCode","type":"uint256"}],"name":"submitVerification","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"uint256","name":"amt","type":"uint256"}],"name":"updateTotalTransactions","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"accountId","type":"string"},{"internalType":"uint256","name":"amt","type":"uint256"}],"name":"updateTransactionCount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"walletStatus","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"}],"devdoc":{"events":{"Paused(address)":{"details":"Emitted when the pause is triggered by `account`."},"Unpaused(address)":{"details":"Emitted when the pause is lifted by `account`."}},"kind":"dev","methods":{"owner()":{"details":"Returns the address of the current owner."},"paused()":{"details":"Returns true if the contract is paused, and false otherwise."},"renounceOwnership()":{"details":"Leaves the contract without owner. It will not be possible to call `onlyOwner` functions. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby disabling any functionality that is only available to the owner."},"transferOwnership(address)":{"details":"Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner."}},"version":1},"userdoc":{"kind":"user","methods":{},"version":1}},"settings":{"compilationTarget":{"src/Verification.sol":"Verification"},"evmVersion":"paris","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":true,"runs":200},"remappings":[":ds-test/=lib/forge-std/lib/ds-test/src/",":erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",":forge-std/=lib/forge-std/src/",":openzeppelin-contracts/=lib/openzeppelin-contracts/",":openzeppelin/=lib/openzeppelin-contracts/contracts/"]},"sources":{"lib/openzeppelin-contracts/contracts/access/Ownable.sol":{"keccak256":"0xba43b97fba0d32eb4254f6a5a297b39a19a247082a02d6e69349e071e2946218","license":"MIT","urls":["bzz-raw://fc980984badf3984b6303b377711220e067722bbd6a135b24669ff5069ef9f32","dweb:/ipfs/QmPHXMSXj99XjSVM21YsY6aNtLLjLVXDbyN76J5HQYvvrz"]},"lib/openzeppelin-contracts/contracts/security/Pausable.sol":{"keccak256":"0x0849d93b16c9940beb286a7864ed02724b248b93e0d80ef6355af5ef15c64773","license":"MIT","urls":["bzz-raw://4ddabb16009cd17eaca3143feadf450ac13e72919ebe2ca50e00f61cb78bc004","dweb:/ipfs/QmSPwPxX7d6TTWakN5jy5wsaGkS1y9TW8fuhGSraMkLk2B"]},"lib/openzeppelin-contracts/contracts/utils/Context.sol":{"keccak256":"0xe2e337e6dde9ef6b680e07338c493ebea1b5fd09b43424112868e9cc1706bca7","license":"MIT","urls":["bzz-raw://6df0ddf21ce9f58271bdfaa85cde98b200ef242a05a3f85c2bc10a8294800a92","dweb:/ipfs/QmRK2Y5Yc6BK7tGKkgsgn3aJEQGi5aakeSPZvS65PV8Xp3"]},"src/Verification.sol":{"keccak256":"0xd53d070d7f0797f3f7a4ac92b9df18d995fb1228c491b065a366358e4f9d9e39","license":"MIT","urls":["bzz-raw://a40487231bfc2e36f21cb3cc65d11441b2881209c8844c9c23f5c2be5c5d1212","dweb:/ipfs/QmTeQUF5pAV8Mvd8ynP1VhntBCKtgFTGMTfkasxyikn1vc"]}},"version":1}',
  metadata: {
    compiler: {
      version: '0.8.23+commit.f704f362',
    },
    language: 'Solidity',
    output: {
      abi: [
        {
          inputs: [
            {
              internalType: 'uint256',
              name: 'maxTransactions',
              type: 'uint256',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'constructor',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'previousOwner',
              type: 'address',
              indexed: true,
            },
            {
              internalType: 'address',
              name: 'newOwner',
              type: 'address',
              indexed: true,
            },
          ],
          type: 'event',
          name: 'OwnershipTransferred',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'account',
              type: 'address',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'Paused',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
              indexed: true,
            },
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
              indexed: false,
            },
            {
              internalType: 'uint256',
              name: 'amt',
              type: 'uint256',
              indexed: false,
            },
            {
              internalType: 'uint256',
              name: 'total',
              type: 'uint256',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'TotalTransactionsUpdated',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'account',
              type: 'address',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'Unpaused',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
              indexed: true,
            },
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
              indexed: false,
            },
            {
              internalType: 'uint256',
              name: 'verificationCode',
              type: 'uint256',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'VerificationSubmitted',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
              indexed: true,
            },
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'WalletAdded',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
              indexed: true,
            },
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
              indexed: false,
            },
          ],
          type: 'event',
          name: 'WalletPermissionsRevoked',
          anonymous: false,
        },
        {
          inputs: [
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'accountStatus',
          outputs: [
            {
              internalType: 'uint256',
              name: '',
              type: 'uint256',
            },
          ],
        },
        {
          inputs: [
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
            },
            {
              internalType: 'uint256',
              name: 'amt',
              type: 'uint256',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'acctUnderLimit',
          outputs: [
            {
              internalType: 'bool',
              name: '',
              type: 'bool',
            },
          ],
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
            },
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'addVerifiedWallet',
        },
        {
          inputs: [
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'getAccountTransactionsTotal',
          outputs: [
            {
              internalType: 'uint256',
              name: '',
              type: 'uint256',
            },
          ],
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'getAccountUserView',
          outputs: [
            {
              internalType: 'struct Verification.AccountUserView',
              name: 'accountUserView',
              type: 'tuple',
              components: [
                {
                  internalType: 'uint256',
                  name: 'status',
                  type: 'uint256',
                },
                {
                  internalType: 'uint256',
                  name: 'currentTotalTransactions',
                  type: 'uint256',
                },
                {
                  internalType: 'uint256',
                  name: 'maxTransactions',
                  type: 'uint256',
                },
              ],
            },
          ],
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'getWalletAccountId',
          outputs: [
            {
              internalType: 'string',
              name: '',
              type: 'string',
            },
          ],
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'getWalletTransactionsTotal',
          outputs: [
            {
              internalType: 'uint256',
              name: '',
              type: 'uint256',
            },
          ],
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'amt',
              type: 'uint256',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'isValid',
          outputs: [
            {
              internalType: 'bool',
              name: '',
              type: 'bool',
            },
          ],
        },
        {
          inputs: [],
          stateMutability: 'view',
          type: 'function',
          name: 'owner',
          outputs: [
            {
              internalType: 'address',
              name: '',
              type: 'address',
            },
          ],
        },
        {
          inputs: [],
          stateMutability: 'view',
          type: 'function',
          name: 'paused',
          outputs: [
            {
              internalType: 'bool',
              name: '',
              type: 'bool',
            },
          ],
        },
        {
          inputs: [],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'renounceOwnership',
        },
        {
          inputs: [
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'revokeAccountPermissions',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'revokeWalletPermissions',
        },
        {
          inputs: [
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
            },
            {
              internalType: 'uint256',
              name: 'maxTransactions',
              type: 'uint256',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'setTransactionLimits',
        },
        {
          inputs: [
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
            },
            {
              internalType: 'uint256',
              name: 'verificationCode',
              type: 'uint256',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'submitVerification',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'newOwner',
              type: 'address',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'transferOwnership',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'amt',
              type: 'uint256',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'updateTotalTransactions',
        },
        {
          inputs: [
            {
              internalType: 'string',
              name: 'accountId',
              type: 'string',
            },
            {
              internalType: 'uint256',
              name: 'amt',
              type: 'uint256',
            },
          ],
          stateMutability: 'nonpayable',
          type: 'function',
          name: 'updateTransactionCount',
        },
        {
          inputs: [
            {
              internalType: 'address',
              name: 'wallet',
              type: 'address',
            },
          ],
          stateMutability: 'view',
          type: 'function',
          name: 'walletStatus',
          outputs: [
            {
              internalType: 'uint256',
              name: '',
              type: 'uint256',
            },
          ],
        },
      ],
      devdoc: {
        kind: 'dev',
        methods: {
          'owner()': {
            details: 'Returns the address of the current owner.',
          },
          'paused()': {
            details:
              'Returns true if the contract is paused, and false otherwise.',
          },
          'renounceOwnership()': {
            details:
              'Leaves the contract without owner. It will not be possible to call `onlyOwner` functions. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby disabling any functionality that is only available to the owner.',
          },
          'transferOwnership(address)': {
            details:
              'Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner.',
          },
        },
        version: 1,
      },
      userdoc: {
        kind: 'user',
        methods: {},
        version: 1,
      },
    },
    settings: {
      remappings: [
        'ds-test/=lib/forge-std/lib/ds-test/src/',
        'erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/',
        'forge-std/=lib/forge-std/src/',
        'openzeppelin-contracts/=lib/openzeppelin-contracts/',
        'openzeppelin/=lib/openzeppelin-contracts/contracts/',
      ],
      optimizer: {
        enabled: true,
        runs: 200,
      },
      metadata: {
        bytecodeHash: 'ipfs',
      },
      compilationTarget: {
        'src/Verification.sol': 'Verification',
      },
      libraries: {},
    },
    sources: {
      'lib/openzeppelin-contracts/contracts/access/Ownable.sol': {
        keccak256:
          '0xba43b97fba0d32eb4254f6a5a297b39a19a247082a02d6e69349e071e2946218',
        urls: [
          'bzz-raw://fc980984badf3984b6303b377711220e067722bbd6a135b24669ff5069ef9f32',
          'dweb:/ipfs/QmPHXMSXj99XjSVM21YsY6aNtLLjLVXDbyN76J5HQYvvrz',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/security/Pausable.sol': {
        keccak256:
          '0x0849d93b16c9940beb286a7864ed02724b248b93e0d80ef6355af5ef15c64773',
        urls: [
          'bzz-raw://4ddabb16009cd17eaca3143feadf450ac13e72919ebe2ca50e00f61cb78bc004',
          'dweb:/ipfs/QmSPwPxX7d6TTWakN5jy5wsaGkS1y9TW8fuhGSraMkLk2B',
        ],
        license: 'MIT',
      },
      'lib/openzeppelin-contracts/contracts/utils/Context.sol': {
        keccak256:
          '0xe2e337e6dde9ef6b680e07338c493ebea1b5fd09b43424112868e9cc1706bca7',
        urls: [
          'bzz-raw://6df0ddf21ce9f58271bdfaa85cde98b200ef242a05a3f85c2bc10a8294800a92',
          'dweb:/ipfs/QmRK2Y5Yc6BK7tGKkgsgn3aJEQGi5aakeSPZvS65PV8Xp3',
        ],
        license: 'MIT',
      },
      'src/Verification.sol': {
        keccak256:
          '0xd53d070d7f0797f3f7a4ac92b9df18d995fb1228c491b065a366358e4f9d9e39',
        urls: [
          'bzz-raw://a40487231bfc2e36f21cb3cc65d11441b2881209c8844c9c23f5c2be5c5d1212',
          'dweb:/ipfs/QmTeQUF5pAV8Mvd8ynP1VhntBCKtgFTGMTfkasxyikn1vc',
        ],
        license: 'MIT',
      },
    },
    version: 1,
  },
  ast: {
    absolutePath: 'src/Verification.sol',
    id: 50405,
    exportedSymbols: {
      Context: [45392],
      Ownable: [43500],
      Pausable: [43735],
      Verification: [50404],
    },
    nodeType: 'SourceUnit',
    src: '32:5480:47',
    nodes: [
      {
        id: 49957,
        nodeType: 'PragmaDirective',
        src: '32:23:47',
        nodes: [],
        literals: ['solidity', '^', '0.8', '.0'],
      },
      {
        id: 49958,
        nodeType: 'ImportDirective',
        src: '57:68:47',
        nodes: [],
        absolutePath: 'lib/openzeppelin-contracts/contracts/access/Ownable.sol',
        file: '../lib/openzeppelin-contracts/contracts/access/Ownable.sol',
        nameLocation: '-1:-1:-1',
        scope: 50405,
        sourceUnit: 43501,
        symbolAliases: [],
        unitAlias: '',
      },
      {
        id: 49959,
        nodeType: 'ImportDirective',
        src: '126:71:47',
        nodes: [],
        absolutePath:
          'lib/openzeppelin-contracts/contracts/security/Pausable.sol',
        file: '../lib/openzeppelin-contracts/contracts/security/Pausable.sol',
        nameLocation: '-1:-1:-1',
        scope: 50405,
        sourceUnit: 43736,
        symbolAliases: [],
        unitAlias: '',
      },
      {
        id: 50404,
        nodeType: 'ContractDefinition',
        src: '199:5312:47',
        nodes: [
          {
            id: 49971,
            nodeType: 'EventDefinition',
            src: '248:126:47',
            nodes: [],
            anonymous: false,
            eventSelector:
              'd1e388b27139dfa0121eda0f658297d301646ecbd515cdcd6cbb5f8a8b5e3250',
            name: 'VerificationSubmitted',
            nameLocation: '254:21:47',
            parameters: {
              id: 49970,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49965,
                  indexed: true,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '301:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49971,
                  src: '285:22:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49964,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '285:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49967,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '324:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49971,
                  src: '317:16:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 49966,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '317:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49969,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'verificationCode',
                  nameLocation: '351:16:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49971,
                  src: '343:24:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 49968,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '343:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '275:98:47',
            },
          },
          {
            id: 49977,
            nodeType: 'EventDefinition',
            src: '379:60:47',
            nodes: [],
            anonymous: false,
            eventSelector:
              'ca84b5dcf6cad89fa3f04555778fabf3d3cd4d90416b33b1ff6b921e197be46a',
            name: 'WalletAdded',
            nameLocation: '385:11:47',
            parameters: {
              id: 49976,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49973,
                  indexed: true,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '413:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49977,
                  src: '397:22:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49972,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '397:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49975,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '428:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49977,
                  src: '421:16:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 49974,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '421:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '396:42:47',
            },
          },
          {
            id: 49987,
            nodeType: 'EventDefinition',
            src: '444:139:47',
            nodes: [],
            anonymous: false,
            eventSelector:
              'c0170907421c01c8c5e20acc75b5ca8406defc5bf4243c5cc72a4045084ecc9f',
            name: 'TotalTransactionsUpdated',
            nameLocation: '450:24:47',
            parameters: {
              id: 49986,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49979,
                  indexed: true,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '500:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49987,
                  src: '484:22:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49978,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '484:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49981,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '523:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49987,
                  src: '516:16:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 49980,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '516:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49983,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'amt',
                  nameLocation: '550:3:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49987,
                  src: '542:11:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 49982,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '542:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49985,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'total',
                  nameLocation: '571:5:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49987,
                  src: '563:13:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 49984,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '563:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '474:108:47',
            },
          },
          {
            id: 49993,
            nodeType: 'EventDefinition',
            src: '588:73:47',
            nodes: [],
            anonymous: false,
            eventSelector:
              '13b53738990ad0224ad8c40fd9356579830f345671a8d78b20fc7b256d08ced8',
            name: 'WalletPermissionsRevoked',
            nameLocation: '594:24:47',
            parameters: {
              id: 49992,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 49989,
                  indexed: true,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '635:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49993,
                  src: '619:22:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 49988,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '619:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 49991,
                  indexed: false,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '650:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 49993,
                  src: '643:16:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 49990,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '643:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '618:42:47',
            },
          },
          {
            id: 49996,
            nodeType: 'VariableDeclaration',
            src: '667:32:47',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: 'STATUS_NOT_VALIDATED',
            nameLocation: '675:20:47',
            scope: 50404,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier: 't_uint256',
              typeString: 'uint256',
            },
            typeName: {
              id: 49994,
              name: 'uint256',
              nodeType: 'ElementaryTypeName',
              src: '667:7:47',
              typeDescriptions: {
                typeIdentifier: 't_uint256',
                typeString: 'uint256',
              },
            },
            value: {
              hexValue: '30',
              id: 49995,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: 'number',
              lValueRequested: false,
              nodeType: 'Literal',
              src: '698:1:47',
              typeDescriptions: {
                typeIdentifier: 't_rational_0_by_1',
                typeString: 'int_const 0',
              },
              value: '0',
            },
            visibility: 'internal',
          },
          {
            id: 49999,
            nodeType: 'VariableDeclaration',
            src: '705:39:47',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: 'STATUS_ATTEMPTED_VALIDATION',
            nameLocation: '713:27:47',
            scope: 50404,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier: 't_uint256',
              typeString: 'uint256',
            },
            typeName: {
              id: 49997,
              name: 'uint256',
              nodeType: 'ElementaryTypeName',
              src: '705:7:47',
              typeDescriptions: {
                typeIdentifier: 't_uint256',
                typeString: 'uint256',
              },
            },
            value: {
              hexValue: '31',
              id: 49998,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: 'number',
              lValueRequested: false,
              nodeType: 'Literal',
              src: '743:1:47',
              typeDescriptions: {
                typeIdentifier: 't_rational_1_by_1',
                typeString: 'int_const 1',
              },
              value: '1',
            },
            visibility: 'internal',
          },
          {
            id: 50002,
            nodeType: 'VariableDeclaration',
            src: '750:27:47',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: 'STATUS_VERIFIED',
            nameLocation: '758:15:47',
            scope: 50404,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier: 't_uint256',
              typeString: 'uint256',
            },
            typeName: {
              id: 50000,
              name: 'uint256',
              nodeType: 'ElementaryTypeName',
              src: '750:7:47',
              typeDescriptions: {
                typeIdentifier: 't_uint256',
                typeString: 'uint256',
              },
            },
            value: {
              hexValue: '32',
              id: 50001,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: 'number',
              lValueRequested: false,
              nodeType: 'Literal',
              src: '776:1:47',
              typeDescriptions: {
                typeIdentifier: 't_rational_2_by_1',
                typeString: 'int_const 2',
              },
              value: '2',
            },
            visibility: 'internal',
          },
          {
            id: 50004,
            nodeType: 'VariableDeclaration',
            src: '783:24:47',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: '_maxTransactions',
            nameLocation: '791:16:47',
            scope: 50404,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier: 't_uint256',
              typeString: 'uint256',
            },
            typeName: {
              id: 50003,
              name: 'uint256',
              nodeType: 'ElementaryTypeName',
              src: '783:7:47',
              typeDescriptions: {
                typeIdentifier: 't_uint256',
                typeString: 'uint256',
              },
            },
            visibility: 'internal',
          },
          {
            id: 50015,
            nodeType: 'StructDefinition',
            src: '814:170:47',
            nodes: [],
            canonicalName: 'Verification.AccountUser',
            members: [
              {
                constant: false,
                id: 50008,
                mutability: 'mutable',
                name: 'wallets',
                nameLocation: '871:7:47',
                nodeType: 'VariableDeclaration',
                scope: 50015,
                src: '843:35:47',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_mapping$_t_address_$_t_uint256_$',
                  typeString: 'mapping(address => uint256)',
                },
                typeName: {
                  id: 50007,
                  keyName: '',
                  keyNameLocation: '-1:-1:-1',
                  keyType: {
                    id: 50005,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '851:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  nodeType: 'Mapping',
                  src: '843:27:47',
                  typeDescriptions: {
                    typeIdentifier: 't_mapping$_t_address_$_t_uint256_$',
                    typeString: 'mapping(address => uint256)',
                  },
                  valueName: '',
                  valueNameLocation: '-1:-1:-1',
                  valueType: {
                    id: 50006,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '862:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                },
                visibility: 'internal',
              },
              {
                constant: false,
                id: 50010,
                mutability: 'mutable',
                name: 'status',
                nameLocation: '896:6:47',
                nodeType: 'VariableDeclaration',
                scope: 50015,
                src: '888:14:47',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 50009,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '888:7:47',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
              {
                constant: false,
                id: 50012,
                mutability: 'mutable',
                name: 'currentTotalTransactions',
                nameLocation: '920:24:47',
                nodeType: 'VariableDeclaration',
                scope: 50015,
                src: '912:32:47',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 50011,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '912:7:47',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
              {
                constant: false,
                id: 50014,
                mutability: 'mutable',
                name: 'maxTransactions',
                nameLocation: '962:15:47',
                nodeType: 'VariableDeclaration',
                scope: 50015,
                src: '954:23:47',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 50013,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '954:7:47',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
            ],
            name: 'AccountUser',
            nameLocation: '821:11:47',
            scope: 50404,
            visibility: 'public',
          },
          {
            id: 50019,
            nodeType: 'VariableDeclaration',
            src: '990:35:47',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: '_wallets',
            nameLocation: '1017:8:47',
            scope: 50404,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier: 't_mapping$_t_address_$_t_string_storage_$',
              typeString: 'mapping(address => string)',
            },
            typeName: {
              id: 50018,
              keyName: '',
              keyNameLocation: '-1:-1:-1',
              keyType: {
                id: 50016,
                name: 'address',
                nodeType: 'ElementaryTypeName',
                src: '998:7:47',
                typeDescriptions: {
                  typeIdentifier: 't_address',
                  typeString: 'address',
                },
              },
              nodeType: 'Mapping',
              src: '990:26:47',
              typeDescriptions: {
                typeIdentifier: 't_mapping$_t_address_$_t_string_storage_$',
                typeString: 'mapping(address => string)',
              },
              valueName: '',
              valueNameLocation: '-1:-1:-1',
              valueType: {
                id: 50017,
                name: 'string',
                nodeType: 'ElementaryTypeName',
                src: '1009:6:47',
                typeDescriptions: {
                  typeIdentifier: 't_string_storage_ptr',
                  typeString: 'string',
                },
              },
            },
            visibility: 'internal',
          },
          {
            id: 50024,
            nodeType: 'VariableDeclaration',
            src: '1031:40:47',
            nodes: [],
            constant: false,
            mutability: 'mutable',
            name: '_accounts',
            nameLocation: '1062:9:47',
            scope: 50404,
            stateVariable: true,
            storageLocation: 'default',
            typeDescriptions: {
              typeIdentifier:
                't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
              typeString: 'mapping(string => struct Verification.AccountUser)',
            },
            typeName: {
              id: 50023,
              keyName: '',
              keyNameLocation: '-1:-1:-1',
              keyType: {
                id: 50020,
                name: 'string',
                nodeType: 'ElementaryTypeName',
                src: '1039:6:47',
                typeDescriptions: {
                  typeIdentifier: 't_string_storage_ptr',
                  typeString: 'string',
                },
              },
              nodeType: 'Mapping',
              src: '1031:30:47',
              typeDescriptions: {
                typeIdentifier:
                  't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                typeString:
                  'mapping(string => struct Verification.AccountUser)',
              },
              valueName: '',
              valueNameLocation: '-1:-1:-1',
              valueType: {
                id: 50022,
                nodeType: 'UserDefinedTypeName',
                pathNode: {
                  id: 50021,
                  name: 'AccountUser',
                  nameLocations: ['1049:11:47'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 50015,
                  src: '1049:11:47',
                },
                referencedDeclaration: 50015,
                src: '1049:11:47',
                typeDescriptions: {
                  typeIdentifier: 't_struct$_AccountUser_$50015_storage_ptr',
                  typeString: 'struct Verification.AccountUser',
                },
              },
            },
            visibility: 'internal',
          },
          {
            id: 50034,
            nodeType: 'FunctionDefinition',
            src: '1078:88:47',
            nodes: [],
            body: {
              id: 50033,
              nodeType: 'Block',
              src: '1115:51:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 50031,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 50029,
                      name: '_maxTransactions',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50004,
                      src: '1125:16:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      id: 50030,
                      name: 'maxTransactions',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50026,
                      src: '1144:15:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    src: '1125:34:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50032,
                  nodeType: 'ExpressionStatement',
                  src: '1125:34:47',
                },
              ],
            },
            implemented: true,
            kind: 'constructor',
            modifiers: [],
            name: '',
            nameLocation: '-1:-1:-1',
            parameters: {
              id: 50027,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50026,
                  mutability: 'mutable',
                  name: 'maxTransactions',
                  nameLocation: '1098:15:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50034,
                  src: '1090:23:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50025,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '1090:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '1089:25:47',
            },
            returnParameters: {
              id: 50028,
              nodeType: 'ParameterList',
              parameters: [],
              src: '1115:0:47',
            },
            scope: 50404,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50065,
            nodeType: 'FunctionDefinition',
            src: '1172:316:47',
            nodes: [],
            body: {
              id: 50064,
              nodeType: 'Block',
              src: '1294:194:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 50048,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 50043,
                          name: '_accounts',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50024,
                          src: '1304:9:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                            typeString:
                              'mapping(string memory => struct Verification.AccountUser storage ref)',
                          },
                        },
                        id: 50045,
                        indexExpression: {
                          id: 50044,
                          name: 'accountId',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50036,
                          src: '1314:9:47',
                          typeDescriptions: {
                            typeIdentifier: 't_string_memory_ptr',
                            typeString: 'string memory',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '1304:20:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage',
                          typeString:
                            'struct Verification.AccountUser storage ref',
                        },
                      },
                      id: 50046,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '1325:6:47',
                      memberName: 'status',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 50010,
                      src: '1304:27:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      id: 50047,
                      name: 'STATUS_ATTEMPTED_VALIDATION',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49999,
                      src: '1334:27:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    src: '1304:57:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50049,
                  nodeType: 'ExpressionStatement',
                  src: '1304:57:47',
                },
                {
                  expression: {
                    id: 50055,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 50050,
                        name: '_wallets',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50019,
                        src: '1371:8:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_mapping$_t_address_$_t_string_storage_$',
                          typeString: 'mapping(address => string storage ref)',
                        },
                      },
                      id: 50053,
                      indexExpression: {
                        expression: {
                          id: 50051,
                          name: 'msg',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: '1380:3:47',
                          typeDescriptions: {
                            typeIdentifier: 't_magic_message',
                            typeString: 'msg',
                          },
                        },
                        id: 50052,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '1384:6:47',
                        memberName: 'sender',
                        nodeType: 'MemberAccess',
                        src: '1380:10:47',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: 'IndexAccess',
                      src: '1371:20:47',
                      typeDescriptions: {
                        typeIdentifier: 't_string_storage',
                        typeString: 'string storage ref',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      id: 50054,
                      name: 'accountId',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50036,
                      src: '1394:9:47',
                      typeDescriptions: {
                        typeIdentifier: 't_string_memory_ptr',
                        typeString: 'string memory',
                      },
                    },
                    src: '1371:32:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage',
                      typeString: 'string storage ref',
                    },
                  },
                  id: 50056,
                  nodeType: 'ExpressionStatement',
                  src: '1371:32:47',
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        expression: {
                          id: 50058,
                          name: 'msg',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: '1441:3:47',
                          typeDescriptions: {
                            typeIdentifier: 't_magic_message',
                            typeString: 'msg',
                          },
                        },
                        id: 50059,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '1445:6:47',
                        memberName: 'sender',
                        nodeType: 'MemberAccess',
                        src: '1441:10:47',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      {
                        id: 50060,
                        name: 'accountId',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50036,
                        src: '1453:9:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_memory_ptr',
                          typeString: 'string memory',
                        },
                      },
                      {
                        id: 50061,
                        name: 'verificationCode',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50038,
                        src: '1464:16:47',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                        {
                          typeIdentifier: 't_string_memory_ptr',
                          typeString: 'string memory',
                        },
                        {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      ],
                      id: 50057,
                      name: 'VerificationSubmitted',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49971,
                      src: '1419:21:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_event_nonpayable$_t_address_$_t_string_memory_ptr_$_t_uint256_$returns$__$',
                        typeString: 'function (address,string memory,uint256)',
                      },
                    },
                    id: 50062,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '1419:62:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 50063,
                  nodeType: 'EmitStatement',
                  src: '1414:67:47',
                },
              ],
            },
            functionSelector: '74cbf076',
            implemented: true,
            kind: 'function',
            modifiers: [
              {
                id: 50041,
                kind: 'modifierInvocation',
                modifierName: {
                  id: 50040,
                  name: 'whenNotPaused',
                  nameLocations: ['1280:13:47'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 43662,
                  src: '1280:13:47',
                },
                nodeType: 'ModifierInvocation',
                src: '1280:13:47',
              },
            ],
            name: 'submitVerification',
            nameLocation: '1181:18:47',
            parameters: {
              id: 50039,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50036,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '1223:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50065,
                  src: '1209:23:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50035,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '1209:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 50038,
                  mutability: 'mutable',
                  name: 'verificationCode',
                  nameLocation: '1250:16:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50065,
                  src: '1242:24:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50037,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '1242:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '1199:73:47',
            },
            returnParameters: {
              id: 50042,
              nodeType: 'ParameterList',
              parameters: [],
              src: '1294:0:47',
            },
            scope: 50404,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50109,
            nodeType: 'FunctionDefinition',
            src: '1494:368:47',
            nodes: [],
            body: {
              id: 50108,
              nodeType: 'Block',
              src: '1601:261:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 50081,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        expression: {
                          baseExpression: {
                            id: 50074,
                            name: '_accounts',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50024,
                            src: '1611:9:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                              typeString:
                                'mapping(string memory => struct Verification.AccountUser storage ref)',
                            },
                          },
                          id: 50076,
                          indexExpression: {
                            id: 50075,
                            name: 'accountId',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50069,
                            src: '1621:9:47',
                            typeDescriptions: {
                              typeIdentifier: 't_string_memory_ptr',
                              typeString: 'string memory',
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: 'IndexAccess',
                          src: '1611:20:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_struct$_AccountUser_$50015_storage',
                            typeString:
                              'struct Verification.AccountUser storage ref',
                          },
                        },
                        id: 50077,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '1632:7:47',
                        memberName: 'wallets',
                        nodeType: 'MemberAccess',
                        referencedDeclaration: 50008,
                        src: '1611:28:47',
                        typeDescriptions: {
                          typeIdentifier: 't_mapping$_t_address_$_t_uint256_$',
                          typeString: 'mapping(address => uint256)',
                        },
                      },
                      id: 50079,
                      indexExpression: {
                        id: 50078,
                        name: 'wallet',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50067,
                        src: '1640:6:47',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: 'IndexAccess',
                      src: '1611:36:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '31',
                      id: 50080,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '1650:1:47',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_1_by_1',
                        typeString: 'int_const 1',
                      },
                      value: '1',
                    },
                    src: '1611:40:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50082,
                  nodeType: 'ExpressionStatement',
                  src: '1611:40:47',
                },
                {
                  expression: {
                    id: 50088,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 50083,
                          name: '_accounts',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50024,
                          src: '1661:9:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                            typeString:
                              'mapping(string memory => struct Verification.AccountUser storage ref)',
                          },
                        },
                        id: 50085,
                        indexExpression: {
                          id: 50084,
                          name: 'accountId',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50069,
                          src: '1671:9:47',
                          typeDescriptions: {
                            typeIdentifier: 't_string_memory_ptr',
                            typeString: 'string memory',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '1661:20:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage',
                          typeString:
                            'struct Verification.AccountUser storage ref',
                        },
                      },
                      id: 50086,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '1682:15:47',
                      memberName: 'maxTransactions',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 50014,
                      src: '1661:36:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      id: 50087,
                      name: '_maxTransactions',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50004,
                      src: '1700:16:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    src: '1661:55:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50089,
                  nodeType: 'ExpressionStatement',
                  src: '1661:55:47',
                },
                {
                  expression: {
                    id: 50095,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 50090,
                          name: '_accounts',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50024,
                          src: '1726:9:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                            typeString:
                              'mapping(string memory => struct Verification.AccountUser storage ref)',
                          },
                        },
                        id: 50092,
                        indexExpression: {
                          id: 50091,
                          name: 'accountId',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50069,
                          src: '1736:9:47',
                          typeDescriptions: {
                            typeIdentifier: 't_string_memory_ptr',
                            typeString: 'string memory',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '1726:20:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage',
                          typeString:
                            'struct Verification.AccountUser storage ref',
                        },
                      },
                      id: 50093,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '1747:6:47',
                      memberName: 'status',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 50010,
                      src: '1726:27:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      id: 50094,
                      name: 'STATUS_VERIFIED',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50002,
                      src: '1756:15:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    src: '1726:45:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50096,
                  nodeType: 'ExpressionStatement',
                  src: '1726:45:47',
                },
                {
                  expression: {
                    id: 50101,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 50097,
                        name: '_wallets',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50019,
                        src: '1781:8:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_mapping$_t_address_$_t_string_storage_$',
                          typeString: 'mapping(address => string storage ref)',
                        },
                      },
                      id: 50099,
                      indexExpression: {
                        id: 50098,
                        name: 'wallet',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50067,
                        src: '1790:6:47',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: 'IndexAccess',
                      src: '1781:16:47',
                      typeDescriptions: {
                        typeIdentifier: 't_string_storage',
                        typeString: 'string storage ref',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      id: 50100,
                      name: 'accountId',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50069,
                      src: '1800:9:47',
                      typeDescriptions: {
                        typeIdentifier: 't_string_memory_ptr',
                        typeString: 'string memory',
                      },
                    },
                    src: '1781:28:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage',
                      typeString: 'string storage ref',
                    },
                  },
                  id: 50102,
                  nodeType: 'ExpressionStatement',
                  src: '1781:28:47',
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 50104,
                        name: 'wallet',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50067,
                        src: '1837:6:47',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      {
                        id: 50105,
                        name: 'accountId',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50069,
                        src: '1845:9:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_memory_ptr',
                          typeString: 'string memory',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                        {
                          typeIdentifier: 't_string_memory_ptr',
                          typeString: 'string memory',
                        },
                      ],
                      id: 50103,
                      name: 'WalletAdded',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49977,
                      src: '1825:11:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_event_nonpayable$_t_address_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (address,string memory)',
                      },
                    },
                    id: 50106,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '1825:30:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 50107,
                  nodeType: 'EmitStatement',
                  src: '1820:35:47',
                },
              ],
            },
            functionSelector: '16d13df3',
            implemented: true,
            kind: 'function',
            modifiers: [
              {
                id: 50072,
                kind: 'modifierInvocation',
                modifierName: {
                  id: 50071,
                  name: 'onlyOwner',
                  nameLocations: ['1591:9:47'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 43419,
                  src: '1591:9:47',
                },
                nodeType: 'ModifierInvocation',
                src: '1591:9:47',
              },
            ],
            name: 'addVerifiedWallet',
            nameLocation: '1503:17:47',
            parameters: {
              id: 50070,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50067,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '1538:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50109,
                  src: '1530:14:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 50066,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '1530:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 50069,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '1568:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50109,
                  src: '1554:23:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50068,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '1554:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '1520:63:47',
            },
            returnParameters: {
              id: 50073,
              nodeType: 'ParameterList',
              parameters: [],
              src: '1601:0:47',
            },
            scope: 50404,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50135,
            nodeType: 'FunctionDefinition',
            src: '1868:196:47',
            nodes: [],
            body: {
              id: 50134,
              nodeType: 'Block',
              src: '1934:130:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 50125,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        expression: {
                          baseExpression: {
                            id: 50116,
                            name: '_accounts',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50024,
                            src: '1944:9:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                              typeString:
                                'mapping(string memory => struct Verification.AccountUser storage ref)',
                            },
                          },
                          id: 50120,
                          indexExpression: {
                            baseExpression: {
                              id: 50117,
                              name: '_wallets',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 50019,
                              src: '1954:8:47',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_address_$_t_string_storage_$',
                                typeString:
                                  'mapping(address => string storage ref)',
                              },
                            },
                            id: 50119,
                            indexExpression: {
                              id: 50118,
                              name: 'wallet',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 50111,
                              src: '1963:6:47',
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '1954:16:47',
                            typeDescriptions: {
                              typeIdentifier: 't_string_storage',
                              typeString: 'string storage ref',
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: 'IndexAccess',
                          src: '1944:27:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_struct$_AccountUser_$50015_storage',
                            typeString:
                              'struct Verification.AccountUser storage ref',
                          },
                        },
                        id: 50121,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '1972:7:47',
                        memberName: 'wallets',
                        nodeType: 'MemberAccess',
                        referencedDeclaration: 50008,
                        src: '1944:35:47',
                        typeDescriptions: {
                          typeIdentifier: 't_mapping$_t_address_$_t_uint256_$',
                          typeString: 'mapping(address => uint256)',
                        },
                      },
                      id: 50123,
                      indexExpression: {
                        id: 50122,
                        name: 'wallet',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50111,
                        src: '1980:6:47',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: 'IndexAccess',
                      src: '1944:43:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '30',
                      id: 50124,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '1990:1:47',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_0_by_1',
                        typeString: 'int_const 0',
                      },
                      value: '0',
                    },
                    src: '1944:47:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50126,
                  nodeType: 'ExpressionStatement',
                  src: '1944:47:47',
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 50128,
                        name: 'wallet',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50111,
                        src: '2032:6:47',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      {
                        baseExpression: {
                          id: 50129,
                          name: '_wallets',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50019,
                          src: '2040:8:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_string_storage_$',
                            typeString:
                              'mapping(address => string storage ref)',
                          },
                        },
                        id: 50131,
                        indexExpression: {
                          id: 50130,
                          name: 'wallet',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50111,
                          src: '2049:6:47',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '2040:16:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_storage',
                          typeString: 'string storage ref',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                        {
                          typeIdentifier: 't_string_storage',
                          typeString: 'string storage ref',
                        },
                      ],
                      id: 50127,
                      name: 'WalletPermissionsRevoked',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49993,
                      src: '2007:24:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_event_nonpayable$_t_address_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (address,string memory)',
                      },
                    },
                    id: 50132,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '2007:50:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 50133,
                  nodeType: 'EmitStatement',
                  src: '2002:55:47',
                },
              ],
            },
            functionSelector: '42599ee8',
            implemented: true,
            kind: 'function',
            modifiers: [
              {
                id: 50114,
                kind: 'modifierInvocation',
                modifierName: {
                  id: 50113,
                  name: 'onlyOwner',
                  nameLocations: ['1924:9:47'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 43419,
                  src: '1924:9:47',
                },
                nodeType: 'ModifierInvocation',
                src: '1924:9:47',
              },
            ],
            name: 'revokeWalletPermissions',
            nameLocation: '1877:23:47',
            parameters: {
              id: 50112,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50111,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '1909:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50135,
                  src: '1901:14:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 50110,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '1901:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '1900:16:47',
            },
            returnParameters: {
              id: 50115,
              nodeType: 'ParameterList',
              parameters: [],
              src: '1934:0:47',
            },
            scope: 50404,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50160,
            nodeType: 'FunctionDefinition',
            src: '2070:283:47',
            nodes: [],
            body: {
              id: 50159,
              nodeType: 'Block',
              src: '2160:193:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        id: 50148,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 50143,
                              name: '_accounts',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 50024,
                              src: '2178:9:47',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                                typeString:
                                  'mapping(string memory => struct Verification.AccountUser storage ref)',
                              },
                            },
                            id: 50145,
                            indexExpression: {
                              id: 50144,
                              name: 'accountId',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 50137,
                              src: '2188:9:47',
                              typeDescriptions: {
                                typeIdentifier: 't_string_memory_ptr',
                                typeString: 'string memory',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '2178:20:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_AccountUser_$50015_storage',
                              typeString:
                                'struct Verification.AccountUser storage ref',
                            },
                          },
                          id: 50146,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '2199:6:47',
                          memberName: 'status',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 50010,
                          src: '2178:27:47',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '!=',
                        rightExpression: {
                          hexValue: '30',
                          id: 50147,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: 'number',
                          lValueRequested: false,
                          nodeType: 'Literal',
                          src: '2209:1:47',
                          typeDescriptions: {
                            typeIdentifier: 't_rational_0_by_1',
                            typeString: 'int_const 0',
                          },
                          value: '0',
                        },
                        src: '2178:32:47',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue: '4163636f756e74206e6f7420666f756e64',
                        id: 50149,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '2212:19:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_7abe52de70d7c50fc0a1c7e87b6378ae4f77a3fdb3d81424a15f2135c479b559',
                          typeString: 'literal_string "Account not found"',
                        },
                        value: 'Account not found',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_7abe52de70d7c50fc0a1c7e87b6378ae4f77a3fdb3d81424a15f2135c479b559',
                          typeString: 'literal_string "Account not found"',
                        },
                      ],
                      id: 50142,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '2170:7:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 50150,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '2170:62:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 50151,
                  nodeType: 'ExpressionStatement',
                  src: '2170:62:47',
                },
                {
                  expression: {
                    id: 50157,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 50152,
                          name: '_accounts',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50024,
                          src: '2315:9:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                            typeString:
                              'mapping(string memory => struct Verification.AccountUser storage ref)',
                          },
                        },
                        id: 50154,
                        indexExpression: {
                          id: 50153,
                          name: 'accountId',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50137,
                          src: '2325:9:47',
                          typeDescriptions: {
                            typeIdentifier: 't_string_memory_ptr',
                            typeString: 'string memory',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '2315:20:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage',
                          typeString:
                            'struct Verification.AccountUser storage ref',
                        },
                      },
                      id: 50155,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '2336:6:47',
                      memberName: 'status',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 50010,
                      src: '2315:27:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      hexValue: '30',
                      id: 50156,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: 'number',
                      lValueRequested: false,
                      nodeType: 'Literal',
                      src: '2345:1:47',
                      typeDescriptions: {
                        typeIdentifier: 't_rational_0_by_1',
                        typeString: 'int_const 0',
                      },
                      value: '0',
                    },
                    src: '2315:31:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50158,
                  nodeType: 'ExpressionStatement',
                  src: '2315:31:47',
                },
              ],
            },
            functionSelector: 'f5d68652',
            implemented: true,
            kind: 'function',
            modifiers: [
              {
                id: 50140,
                kind: 'modifierInvocation',
                modifierName: {
                  id: 50139,
                  name: 'onlyOwner',
                  nameLocations: ['2150:9:47'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 43419,
                  src: '2150:9:47',
                },
                nodeType: 'ModifierInvocation',
                src: '2150:9:47',
              },
            ],
            name: 'revokeAccountPermissions',
            nameLocation: '2079:24:47',
            parameters: {
              id: 50138,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50137,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '2127:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50160,
                  src: '2113:23:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50136,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '2113:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2103:39:47',
            },
            returnParameters: {
              id: 50141,
              nodeType: 'ParameterList',
              parameters: [],
              src: '2160:0:47',
            },
            scope: 50404,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50183,
            nodeType: 'FunctionDefinition',
            src: '2359:252:47',
            nodes: [],
            body: {
              id: 50182,
              nodeType: 'Block',
              src: '2470:141:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    commonType: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                    id: 50180,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      components: [
                        {
                          commonType: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                          id: 50174,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              baseExpression: {
                                id: 50169,
                                name: '_accounts',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: 50024,
                                src: '2500:9:47',
                                typeDescriptions: {
                                  typeIdentifier:
                                    't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                                  typeString:
                                    'mapping(string memory => struct Verification.AccountUser storage ref)',
                                },
                              },
                              id: 50171,
                              indexExpression: {
                                id: 50170,
                                name: 'accountId',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: 50162,
                                src: '2510:9:47',
                                typeDescriptions: {
                                  typeIdentifier: 't_string_memory_ptr',
                                  typeString: 'string memory',
                                },
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: 'IndexAccess',
                              src: '2500:20:47',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_struct$_AccountUser_$50015_storage',
                                typeString:
                                  'struct Verification.AccountUser storage ref',
                              },
                            },
                            id: 50172,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '2521:24:47',
                            memberName: 'currentTotalTransactions',
                            nodeType: 'MemberAccess',
                            referencedDeclaration: 50012,
                            src: '2500:45:47',
                            typeDescriptions: {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          },
                          nodeType: 'BinaryOperation',
                          operator: '+',
                          rightExpression: {
                            id: 50173,
                            name: 'amt',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50164,
                            src: '2548:3:47',
                            typeDescriptions: {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          },
                          src: '2500:51:47',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                      ],
                      id: 50175,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: 'TupleExpression',
                      src: '2499:53:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'BinaryOperation',
                    operator: '<=',
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 50176,
                          name: '_accounts',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50024,
                          src: '2568:9:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                            typeString:
                              'mapping(string memory => struct Verification.AccountUser storage ref)',
                          },
                        },
                        id: 50178,
                        indexExpression: {
                          id: 50177,
                          name: 'accountId',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50162,
                          src: '2578:9:47',
                          typeDescriptions: {
                            typeIdentifier: 't_string_memory_ptr',
                            typeString: 'string memory',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '2568:20:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage',
                          typeString:
                            'struct Verification.AccountUser storage ref',
                        },
                      },
                      id: 50179,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: '2589:15:47',
                      memberName: 'maxTransactions',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 50014,
                      src: '2568:36:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    src: '2499:105:47',
                    typeDescriptions: {
                      typeIdentifier: 't_bool',
                      typeString: 'bool',
                    },
                  },
                  functionReturnParameters: 50168,
                  id: 50181,
                  nodeType: 'Return',
                  src: '2480:124:47',
                },
              ],
            },
            functionSelector: '8297822c',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'acctUnderLimit',
            nameLocation: '2368:14:47',
            parameters: {
              id: 50165,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50162,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '2406:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50183,
                  src: '2392:23:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50161,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '2392:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 50164,
                  mutability: 'mutable',
                  name: 'amt',
                  nameLocation: '2433:3:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50183,
                  src: '2425:11:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50163,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '2425:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2382:60:47',
            },
            returnParameters: {
              id: 50168,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50167,
                  mutability: 'mutable',
                  name: '',
                  nameLocation: '-1:-1:-1',
                  nodeType: 'VariableDeclaration',
                  scope: 50183,
                  src: '2464:4:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_bool',
                    typeString: 'bool',
                  },
                  typeName: {
                    id: 50166,
                    name: 'bool',
                    nodeType: 'ElementaryTypeName',
                    src: '2464:4:47',
                    typeDescriptions: {
                      typeIdentifier: 't_bool',
                      typeString: 'bool',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2463:6:47',
            },
            scope: 50404,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50196,
            nodeType: 'FunctionDefinition',
            src: '2617:175:47',
            nodes: [],
            body: {
              id: 50195,
              nodeType: 'Block',
              src: '2723:69:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    expression: {
                      baseExpression: {
                        id: 50190,
                        name: '_accounts',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50024,
                        src: '2740:9:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                          typeString:
                            'mapping(string memory => struct Verification.AccountUser storage ref)',
                        },
                      },
                      id: 50192,
                      indexExpression: {
                        id: 50191,
                        name: 'accountId',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50185,
                        src: '2750:9:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_memory_ptr',
                          typeString: 'string memory',
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: 'IndexAccess',
                      src: '2740:20:47',
                      typeDescriptions: {
                        typeIdentifier: 't_struct$_AccountUser_$50015_storage',
                        typeString:
                          'struct Verification.AccountUser storage ref',
                      },
                    },
                    id: 50193,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: '2761:24:47',
                    memberName: 'currentTotalTransactions',
                    nodeType: 'MemberAccess',
                    referencedDeclaration: 50012,
                    src: '2740:45:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  functionReturnParameters: 50189,
                  id: 50194,
                  nodeType: 'Return',
                  src: '2733:52:47',
                },
              ],
            },
            functionSelector: 'a95608a9',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'getAccountTransactionsTotal',
            nameLocation: '2626:27:47',
            parameters: {
              id: 50186,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50185,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '2677:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50196,
                  src: '2663:23:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50184,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '2663:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2653:39:47',
            },
            returnParameters: {
              id: 50189,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50188,
                  mutability: 'mutable',
                  name: '',
                  nameLocation: '-1:-1:-1',
                  nodeType: 'VariableDeclaration',
                  scope: 50196,
                  src: '2714:7:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50187,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '2714:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2713:9:47',
            },
            scope: 50404,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50210,
            nodeType: 'FunctionDefinition',
            src: '2798:165:47',
            nodes: [],
            body: {
              id: 50209,
              nodeType: 'Block',
              src: '2894:69:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        baseExpression: {
                          id: 50204,
                          name: '_wallets',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50019,
                          src: '2939:8:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_string_storage_$',
                            typeString:
                              'mapping(address => string storage ref)',
                          },
                        },
                        id: 50206,
                        indexExpression: {
                          id: 50205,
                          name: 'wallet',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50198,
                          src: '2948:6:47',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '2939:16:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_storage',
                          typeString: 'string storage ref',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_string_storage',
                          typeString: 'string storage ref',
                        },
                      ],
                      id: 50203,
                      name: 'getAccountTransactionsTotal',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50196,
                      src: '2911:27:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_internal_view$_t_string_memory_ptr_$returns$_t_uint256_$',
                        typeString:
                          'function (string memory) view returns (uint256)',
                      },
                    },
                    id: 50207,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '2911:45:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  functionReturnParameters: 50202,
                  id: 50208,
                  nodeType: 'Return',
                  src: '2904:52:47',
                },
              ],
            },
            functionSelector: '4bb63e10',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'getWalletTransactionsTotal',
            nameLocation: '2807:26:47',
            parameters: {
              id: 50199,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50198,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '2851:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50210,
                  src: '2843:14:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 50197,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '2843:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2833:30:47',
            },
            returnParameters: {
              id: 50202,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50201,
                  mutability: 'mutable',
                  name: '',
                  nameLocation: '-1:-1:-1',
                  nodeType: 'VariableDeclaration',
                  scope: 50210,
                  src: '2885:7:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50200,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '2885:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2884:9:47',
            },
            scope: 50404,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50257,
            nodeType: 'FunctionDefinition',
            src: '2969:496:47',
            nodes: [],
            body: {
              id: 50256,
              nodeType: 'Block',
              src: '3042:423:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        id: 50229,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          baseExpression: {
                            expression: {
                              baseExpression: {
                                id: 50220,
                                name: '_accounts',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: 50024,
                                src: '3073:9:47',
                                typeDescriptions: {
                                  typeIdentifier:
                                    't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                                  typeString:
                                    'mapping(string memory => struct Verification.AccountUser storage ref)',
                                },
                              },
                              id: 50224,
                              indexExpression: {
                                baseExpression: {
                                  id: 50221,
                                  name: '_wallets',
                                  nodeType: 'Identifier',
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 50019,
                                  src: '3083:8:47',
                                  typeDescriptions: {
                                    typeIdentifier:
                                      't_mapping$_t_address_$_t_string_storage_$',
                                    typeString:
                                      'mapping(address => string storage ref)',
                                  },
                                },
                                id: 50223,
                                indexExpression: {
                                  id: 50222,
                                  name: 'wallet',
                                  nodeType: 'Identifier',
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 50212,
                                  src: '3092:6:47',
                                  typeDescriptions: {
                                    typeIdentifier: 't_address',
                                    typeString: 'address',
                                  },
                                },
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                nodeType: 'IndexAccess',
                                src: '3083:16:47',
                                typeDescriptions: {
                                  typeIdentifier: 't_string_storage',
                                  typeString: 'string storage ref',
                                },
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: 'IndexAccess',
                              src: '3073:27:47',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_struct$_AccountUser_$50015_storage',
                                typeString:
                                  'struct Verification.AccountUser storage ref',
                              },
                            },
                            id: 50225,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: '3101:7:47',
                            memberName: 'wallets',
                            nodeType: 'MemberAccess',
                            referencedDeclaration: 50008,
                            src: '3073:35:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_mapping$_t_address_$_t_uint256_$',
                              typeString: 'mapping(address => uint256)',
                            },
                          },
                          id: 50227,
                          indexExpression: {
                            id: 50226,
                            name: 'wallet',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50212,
                            src: '3109:6:47',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: 'IndexAccess',
                          src: '3073:43:47',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '!=',
                        rightExpression: {
                          hexValue: '30',
                          id: 50228,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: 'number',
                          lValueRequested: false,
                          nodeType: 'Literal',
                          src: '3120:1:47',
                          typeDescriptions: {
                            typeIdentifier: 't_rational_0_by_1',
                            typeString: 'int_const 0',
                          },
                          value: '0',
                        },
                        src: '3073:48:47',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '57616c6c6574206e6f74206173736f636961746564207769746820616e206163636f756e74',
                        id: 50230,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '3135:39:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_72e72fb5783c56ffb2f9562e3aaf86019fdfbdd4e0f1aa89c986017129b8fa51',
                          typeString:
                            'literal_string "Wallet not associated with an account"',
                        },
                        value: 'Wallet not associated with an account',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_72e72fb5783c56ffb2f9562e3aaf86019fdfbdd4e0f1aa89c986017129b8fa51',
                          typeString:
                            'literal_string "Wallet not associated with an account"',
                        },
                      ],
                      id: 50219,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '3052:7:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 50231,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3052:132:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 50232,
                  nodeType: 'ExpressionStatement',
                  src: '3052:132:47',
                },
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        id: 50240,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          arguments: [
                            {
                              baseExpression: {
                                id: 50235,
                                name: '_wallets',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: 50019,
                                src: '3229:8:47',
                                typeDescriptions: {
                                  typeIdentifier:
                                    't_mapping$_t_address_$_t_string_storage_$',
                                  typeString:
                                    'mapping(address => string storage ref)',
                                },
                              },
                              id: 50237,
                              indexExpression: {
                                id: 50236,
                                name: 'wallet',
                                nodeType: 'Identifier',
                                overloadedDeclarations: [],
                                referencedDeclaration: 50212,
                                src: '3238:6:47',
                                typeDescriptions: {
                                  typeIdentifier: 't_address',
                                  typeString: 'address',
                                },
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: 'IndexAccess',
                              src: '3229:16:47',
                              typeDescriptions: {
                                typeIdentifier: 't_string_storage',
                                typeString: 'string storage ref',
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: 't_string_storage',
                                typeString: 'string storage ref',
                              },
                            ],
                            id: 50234,
                            name: 'accountStatus',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50349,
                            src: '3215:13:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_function_internal_view$_t_string_memory_ptr_$returns$_t_uint256_$',
                              typeString:
                                'function (string memory) view returns (uint256)',
                            },
                          },
                          id: 50238,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: 'functionCall',
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: 'FunctionCall',
                          src: '3215:31:47',
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        nodeType: 'BinaryOperation',
                        operator: '!=',
                        rightExpression: {
                          id: 50239,
                          name: 'STATUS_NOT_VALIDATED',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 49996,
                          src: '3250:20:47',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        src: '3215:55:47',
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue: '4163636f756e74206e6f74207665726966696564',
                        id: 50241,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '3284:22:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_b8c5757999d48d7a3037a827f2ad13d639db19ae1701766ed321ba5b542d0d74',
                          typeString: 'literal_string "Account not verified"',
                        },
                        value: 'Account not verified',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_b8c5757999d48d7a3037a827f2ad13d639db19ae1701766ed321ba5b542d0d74',
                          typeString: 'literal_string "Account not verified"',
                        },
                      ],
                      id: 50233,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '3194:7:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 50242,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3194:122:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 50243,
                  nodeType: 'ExpressionStatement',
                  src: '3194:122:47',
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            baseExpression: {
                              id: 50246,
                              name: '_wallets',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 50019,
                              src: '3362:8:47',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_address_$_t_string_storage_$',
                                typeString:
                                  'mapping(address => string storage ref)',
                              },
                            },
                            id: 50248,
                            indexExpression: {
                              id: 50247,
                              name: 'wallet',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 50212,
                              src: '3371:6:47',
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '3362:16:47',
                            typeDescriptions: {
                              typeIdentifier: 't_string_storage',
                              typeString: 'string storage ref',
                            },
                          },
                          {
                            id: 50249,
                            name: 'amt',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50214,
                            src: '3380:3:47',
                            typeDescriptions: {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: 't_string_storage',
                              typeString: 'string storage ref',
                            },
                            {
                              typeIdentifier: 't_uint256',
                              typeString: 'uint256',
                            },
                          ],
                          id: 50245,
                          name: 'acctUnderLimit',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50183,
                          src: '3347:14:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_function_internal_view$_t_string_memory_ptr_$_t_uint256_$returns$_t_bool_$',
                            typeString:
                              'function (string memory,uint256) view returns (bool)',
                          },
                        },
                        id: 50250,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: 'functionCall',
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: 'FunctionCall',
                        src: '3347:37:47',
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                      },
                      {
                        hexValue:
                          '5472616e73616374696f6e206c696d6974206578636565646564',
                        id: 50251,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: 'string',
                        lValueRequested: false,
                        nodeType: 'Literal',
                        src: '3398:28:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_stringliteral_163e00bf5f1f7331daa048383a7f16d28f2a7601372d25c2304a02ed467cdfc9',
                          typeString:
                            'literal_string "Transaction limit exceeded"',
                        },
                        value: 'Transaction limit exceeded',
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_bool',
                          typeString: 'bool',
                        },
                        {
                          typeIdentifier:
                            't_stringliteral_163e00bf5f1f7331daa048383a7f16d28f2a7601372d25c2304a02ed467cdfc9',
                          typeString:
                            'literal_string "Transaction limit exceeded"',
                        },
                      ],
                      id: 50244,
                      name: 'require',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: '3326:7:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$',
                        typeString: 'function (bool,string memory) pure',
                      },
                    },
                    id: 50252,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3326:110:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 50253,
                  nodeType: 'ExpressionStatement',
                  src: '3326:110:47',
                },
                {
                  expression: {
                    hexValue: '74727565',
                    id: 50254,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: 'bool',
                    lValueRequested: false,
                    nodeType: 'Literal',
                    src: '3454:4:47',
                    typeDescriptions: {
                      typeIdentifier: 't_bool',
                      typeString: 'bool',
                    },
                    value: 'true',
                  },
                  functionReturnParameters: 50218,
                  id: 50255,
                  nodeType: 'Return',
                  src: '3447:11:47',
                },
              ],
            },
            functionSelector: '59647984',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'isValid',
            nameLocation: '2978:7:47',
            parameters: {
              id: 50215,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50212,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '2994:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50257,
                  src: '2986:14:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 50211,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '2986:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 50214,
                  mutability: 'mutable',
                  name: 'amt',
                  nameLocation: '3010:3:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50257,
                  src: '3002:11:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50213,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '3002:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '2985:29:47',
            },
            returnParameters: {
              id: 50218,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50217,
                  mutability: 'mutable',
                  name: '',
                  nameLocation: '-1:-1:-1',
                  nodeType: 'VariableDeclaration',
                  scope: 50257,
                  src: '3036:4:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_bool',
                    typeString: 'bool',
                  },
                  typeName: {
                    id: 50216,
                    name: 'bool',
                    nodeType: 'ElementaryTypeName',
                    src: '3036:4:47',
                    typeDescriptions: {
                      typeIdentifier: 't_bool',
                      typeString: 'bool',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '3035:6:47',
            },
            scope: 50404,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50288,
            nodeType: 'FunctionDefinition',
            src: '3471:595:47',
            nodes: [],
            body: {
              id: 50287,
              nodeType: 'Block',
              src: '3540:526:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 50271,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 50264,
                          name: '_accounts',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50024,
                          src: '3817:9:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                            typeString:
                              'mapping(string memory => struct Verification.AccountUser storage ref)',
                          },
                        },
                        id: 50268,
                        indexExpression: {
                          baseExpression: {
                            id: 50265,
                            name: '_wallets',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50019,
                            src: '3827:8:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_mapping$_t_address_$_t_string_storage_$',
                              typeString:
                                'mapping(address => string storage ref)',
                            },
                          },
                          id: 50267,
                          indexExpression: {
                            id: 50266,
                            name: 'wallet',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50259,
                            src: '3836:6:47',
                            typeDescriptions: {
                              typeIdentifier: 't_address',
                              typeString: 'address',
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: 'IndexAccess',
                          src: '3827:16:47',
                          typeDescriptions: {
                            typeIdentifier: 't_string_storage',
                            typeString: 'string storage ref',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '3817:27:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage',
                          typeString:
                            'struct Verification.AccountUser storage ref',
                        },
                      },
                      id: 50269,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '3845:24:47',
                      memberName: 'currentTotalTransactions',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 50012,
                      src: '3817:52:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '+=',
                    rightHandSide: {
                      id: 50270,
                      name: 'amt',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50261,
                      src: '3873:3:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    src: '3817:59:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50272,
                  nodeType: 'ExpressionStatement',
                  src: '3817:59:47',
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 50274,
                        name: 'wallet',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50259,
                        src: '3930:6:47',
                        typeDescriptions: {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                      },
                      {
                        baseExpression: {
                          id: 50275,
                          name: '_wallets',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50019,
                          src: '3950:8:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_string_storage_$',
                            typeString:
                              'mapping(address => string storage ref)',
                          },
                        },
                        id: 50277,
                        indexExpression: {
                          id: 50276,
                          name: 'wallet',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50259,
                          src: '3959:6:47',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '3950:16:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_storage',
                          typeString: 'string storage ref',
                        },
                      },
                      {
                        id: 50278,
                        name: 'amt',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50261,
                        src: '3980:3:47',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                      {
                        expression: {
                          baseExpression: {
                            id: 50279,
                            name: '_accounts',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50024,
                            src: '3997:9:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                              typeString:
                                'mapping(string memory => struct Verification.AccountUser storage ref)',
                            },
                          },
                          id: 50283,
                          indexExpression: {
                            baseExpression: {
                              id: 50280,
                              name: '_wallets',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 50019,
                              src: '4007:8:47',
                              typeDescriptions: {
                                typeIdentifier:
                                  't_mapping$_t_address_$_t_string_storage_$',
                                typeString:
                                  'mapping(address => string storage ref)',
                              },
                            },
                            id: 50282,
                            indexExpression: {
                              id: 50281,
                              name: 'wallet',
                              nodeType: 'Identifier',
                              overloadedDeclarations: [],
                              referencedDeclaration: 50259,
                              src: '4016:6:47',
                              typeDescriptions: {
                                typeIdentifier: 't_address',
                                typeString: 'address',
                              },
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: 'IndexAccess',
                            src: '4007:16:47',
                            typeDescriptions: {
                              typeIdentifier: 't_string_storage',
                              typeString: 'string storage ref',
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: 'IndexAccess',
                          src: '3997:27:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_struct$_AccountUser_$50015_storage',
                            typeString:
                              'struct Verification.AccountUser storage ref',
                          },
                        },
                        id: 50284,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: '4025:24:47',
                        memberName: 'currentTotalTransactions',
                        nodeType: 'MemberAccess',
                        referencedDeclaration: 50012,
                        src: '3997:52:47',
                        typeDescriptions: {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_address',
                          typeString: 'address',
                        },
                        {
                          typeIdentifier: 't_string_storage',
                          typeString: 'string storage ref',
                        },
                        {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                        {
                          typeIdentifier: 't_uint256',
                          typeString: 'uint256',
                        },
                      ],
                      id: 50273,
                      name: 'TotalTransactionsUpdated',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 49987,
                      src: '3892:24:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_event_nonpayable$_t_address_$_t_string_memory_ptr_$_t_uint256_$_t_uint256_$returns$__$',
                        typeString:
                          'function (address,string memory,uint256,uint256)',
                      },
                    },
                    id: 50285,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '3892:167:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_tuple$__$',
                      typeString: 'tuple()',
                    },
                  },
                  id: 50286,
                  nodeType: 'EmitStatement',
                  src: '3887:172:47',
                },
              ],
            },
            functionSelector: '98368b25',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'updateTotalTransactions',
            nameLocation: '3480:23:47',
            parameters: {
              id: 50262,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50259,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '3512:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50288,
                  src: '3504:14:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 50258,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '3504:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 50261,
                  mutability: 'mutable',
                  name: 'amt',
                  nameLocation: '3528:3:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50288,
                  src: '3520:11:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50260,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '3520:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '3503:29:47',
            },
            returnParameters: {
              id: 50263,
              nodeType: 'ParameterList',
              parameters: [],
              src: '3540:0:47',
            },
            scope: 50404,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50305,
            nodeType: 'FunctionDefinition',
            src: '4072:190:47',
            nodes: [],
            body: {
              id: 50304,
              nodeType: 'Block',
              src: '4191:71:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 50302,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 50297,
                          name: '_accounts',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50024,
                          src: '4201:9:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                            typeString:
                              'mapping(string memory => struct Verification.AccountUser storage ref)',
                          },
                        },
                        id: 50299,
                        indexExpression: {
                          id: 50298,
                          name: 'accountId',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50290,
                          src: '4211:9:47',
                          typeDescriptions: {
                            typeIdentifier: 't_string_memory_ptr',
                            typeString: 'string memory',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '4201:20:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage',
                          typeString:
                            'struct Verification.AccountUser storage ref',
                        },
                      },
                      id: 50300,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '4222:15:47',
                      memberName: 'maxTransactions',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 50014,
                      src: '4201:36:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      id: 50301,
                      name: 'maxTransactions',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50292,
                      src: '4240:15:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    src: '4201:54:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50303,
                  nodeType: 'ExpressionStatement',
                  src: '4201:54:47',
                },
              ],
            },
            functionSelector: '34aa97da',
            implemented: true,
            kind: 'function',
            modifiers: [
              {
                id: 50295,
                kind: 'modifierInvocation',
                modifierName: {
                  id: 50294,
                  name: 'onlyOwner',
                  nameLocations: ['4181:9:47'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 43419,
                  src: '4181:9:47',
                },
                nodeType: 'ModifierInvocation',
                src: '4181:9:47',
              },
            ],
            name: 'setTransactionLimits',
            nameLocation: '4081:20:47',
            parameters: {
              id: 50293,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50290,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '4125:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50305,
                  src: '4111:23:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50289,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '4111:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 50292,
                  mutability: 'mutable',
                  name: 'maxTransactions',
                  nameLocation: '4152:15:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50305,
                  src: '4144:23:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50291,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '4144:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '4101:72:47',
            },
            returnParameters: {
              id: 50296,
              nodeType: 'ParameterList',
              parameters: [],
              src: '4191:0:47',
            },
            scope: 50404,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50322,
            nodeType: 'FunctionDefinition',
            src: '4268:177:47',
            nodes: [],
            body: {
              id: 50321,
              nodeType: 'Block',
              src: '4377:68:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 50319,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 50314,
                          name: '_accounts',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50024,
                          src: '4387:9:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                            typeString:
                              'mapping(string memory => struct Verification.AccountUser storage ref)',
                          },
                        },
                        id: 50316,
                        indexExpression: {
                          id: 50315,
                          name: 'accountId',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50307,
                          src: '4397:9:47',
                          typeDescriptions: {
                            typeIdentifier: 't_string_memory_ptr',
                            typeString: 'string memory',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '4387:20:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage',
                          typeString:
                            'struct Verification.AccountUser storage ref',
                        },
                      },
                      id: 50317,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: '4408:24:47',
                      memberName: 'currentTotalTransactions',
                      nodeType: 'MemberAccess',
                      referencedDeclaration: 50012,
                      src: '4387:45:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      id: 50318,
                      name: 'amt',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50309,
                      src: '4435:3:47',
                      typeDescriptions: {
                        typeIdentifier: 't_uint256',
                        typeString: 'uint256',
                      },
                    },
                    src: '4387:51:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  id: 50320,
                  nodeType: 'ExpressionStatement',
                  src: '4387:51:47',
                },
              ],
            },
            functionSelector: '348a5532',
            implemented: true,
            kind: 'function',
            modifiers: [
              {
                id: 50312,
                kind: 'modifierInvocation',
                modifierName: {
                  id: 50311,
                  name: 'onlyOwner',
                  nameLocations: ['4367:9:47'],
                  nodeType: 'IdentifierPath',
                  referencedDeclaration: 43419,
                  src: '4367:9:47',
                },
                nodeType: 'ModifierInvocation',
                src: '4367:9:47',
              },
            ],
            name: 'updateTransactionCount',
            nameLocation: '4277:22:47',
            parameters: {
              id: 50310,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50307,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '4323:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50322,
                  src: '4309:23:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50306,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '4309:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
                {
                  constant: false,
                  id: 50309,
                  mutability: 'mutable',
                  name: 'amt',
                  nameLocation: '4350:3:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50322,
                  src: '4342:11:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50308,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '4342:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '4299:60:47',
            },
            returnParameters: {
              id: 50313,
              nodeType: 'ParameterList',
              parameters: [],
              src: '4377:0:47',
            },
            scope: 50404,
            stateMutability: 'nonpayable',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50336,
            nodeType: 'FunctionDefinition',
            src: '4451:123:47',
            nodes: [],
            body: {
              id: 50335,
              nodeType: 'Block',
              src: '4519:55:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        baseExpression: {
                          id: 50330,
                          name: '_wallets',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50019,
                          src: '4550:8:47',
                          typeDescriptions: {
                            typeIdentifier:
                              't_mapping$_t_address_$_t_string_storage_$',
                            typeString:
                              'mapping(address => string storage ref)',
                          },
                        },
                        id: 50332,
                        indexExpression: {
                          id: 50331,
                          name: 'wallet',
                          nodeType: 'Identifier',
                          overloadedDeclarations: [],
                          referencedDeclaration: 50324,
                          src: '4559:6:47',
                          typeDescriptions: {
                            typeIdentifier: 't_address',
                            typeString: 'address',
                          },
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: 'IndexAccess',
                        src: '4550:16:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_storage',
                          typeString: 'string storage ref',
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: 't_string_storage',
                          typeString: 'string storage ref',
                        },
                      ],
                      id: 50329,
                      name: 'accountStatus',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50349,
                      src: '4536:13:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_function_internal_view$_t_string_memory_ptr_$returns$_t_uint256_$',
                        typeString:
                          'function (string memory) view returns (uint256)',
                      },
                    },
                    id: 50333,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: 'functionCall',
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: 'FunctionCall',
                    src: '4536:31:47',
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  functionReturnParameters: 50328,
                  id: 50334,
                  nodeType: 'Return',
                  src: '4529:38:47',
                },
              ],
            },
            functionSelector: '4d6d0af8',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'walletStatus',
            nameLocation: '4460:12:47',
            parameters: {
              id: 50325,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50324,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '4481:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50336,
                  src: '4473:14:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 50323,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '4473:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '4472:16:47',
            },
            returnParameters: {
              id: 50328,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50327,
                  mutability: 'mutable',
                  name: '',
                  nameLocation: '-1:-1:-1',
                  nodeType: 'VariableDeclaration',
                  scope: 50336,
                  src: '4510:7:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50326,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '4510:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '4509:9:47',
            },
            scope: 50404,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50349,
            nodeType: 'FunctionDefinition',
            src: '4580:143:47',
            nodes: [],
            body: {
              id: 50348,
              nodeType: 'Block',
              src: '4672:51:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    expression: {
                      baseExpression: {
                        id: 50343,
                        name: '_accounts',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50024,
                        src: '4689:9:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                          typeString:
                            'mapping(string memory => struct Verification.AccountUser storage ref)',
                        },
                      },
                      id: 50345,
                      indexExpression: {
                        id: 50344,
                        name: 'accountId',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50338,
                        src: '4699:9:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_memory_ptr',
                          typeString: 'string memory',
                        },
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: 'IndexAccess',
                      src: '4689:20:47',
                      typeDescriptions: {
                        typeIdentifier: 't_struct$_AccountUser_$50015_storage',
                        typeString:
                          'struct Verification.AccountUser storage ref',
                      },
                    },
                    id: 50346,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: '4710:6:47',
                    memberName: 'status',
                    nodeType: 'MemberAccess',
                    referencedDeclaration: 50010,
                    src: '4689:27:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  functionReturnParameters: 50342,
                  id: 50347,
                  nodeType: 'Return',
                  src: '4682:34:47',
                },
              ],
            },
            functionSelector: '7fcbe329',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'accountStatus',
            nameLocation: '4589:13:47',
            parameters: {
              id: 50339,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50338,
                  mutability: 'mutable',
                  name: 'accountId',
                  nameLocation: '4626:9:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50349,
                  src: '4612:23:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50337,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '4612:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '4602:39:47',
            },
            returnParameters: {
              id: 50342,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50341,
                  mutability: 'mutable',
                  name: '',
                  nameLocation: '-1:-1:-1',
                  nodeType: 'VariableDeclaration',
                  scope: 50349,
                  src: '4663:7:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                  typeName: {
                    id: 50340,
                    name: 'uint256',
                    nodeType: 'ElementaryTypeName',
                    src: '4663:7:47',
                    typeDescriptions: {
                      typeIdentifier: 't_uint256',
                      typeString: 'uint256',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '4662:9:47',
            },
            scope: 50404,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50356,
            nodeType: 'StructDefinition',
            src: '4729:129:47',
            nodes: [],
            canonicalName: 'Verification.AccountUserView',
            members: [
              {
                constant: false,
                id: 50351,
                mutability: 'mutable',
                name: 'status',
                nameLocation: '4770:6:47',
                nodeType: 'VariableDeclaration',
                scope: 50356,
                src: '4762:14:47',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 50350,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '4762:7:47',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
              {
                constant: false,
                id: 50353,
                mutability: 'mutable',
                name: 'currentTotalTransactions',
                nameLocation: '4794:24:47',
                nodeType: 'VariableDeclaration',
                scope: 50356,
                src: '4786:32:47',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 50352,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '4786:7:47',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
              {
                constant: false,
                id: 50355,
                mutability: 'mutable',
                name: 'maxTransactions',
                nameLocation: '4836:15:47',
                nodeType: 'VariableDeclaration',
                scope: 50356,
                src: '4828:23:47',
                stateVariable: false,
                storageLocation: 'default',
                typeDescriptions: {
                  typeIdentifier: 't_uint256',
                  typeString: 'uint256',
                },
                typeName: {
                  id: 50354,
                  name: 'uint256',
                  nodeType: 'ElementaryTypeName',
                  src: '4828:7:47',
                  typeDescriptions: {
                    typeIdentifier: 't_uint256',
                    typeString: 'uint256',
                  },
                },
                visibility: 'internal',
              },
            ],
            name: 'AccountUserView',
            nameLocation: '4736:15:47',
            scope: 50404,
            visibility: 'public',
          },
          {
            id: 50391,
            nodeType: 'FunctionDefinition',
            src: '4864:505:47',
            nodes: [],
            body: {
              id: 50390,
              nodeType: 'Block',
              src: '4983:386:47',
              nodes: [],
              statements: [
                {
                  assignments: [50365],
                  declarations: [
                    {
                      constant: false,
                      id: 50365,
                      mutability: 'mutable',
                      name: 'accountId',
                      nameLocation: '5007:9:47',
                      nodeType: 'VariableDeclaration',
                      scope: 50390,
                      src: '4993:23:47',
                      stateVariable: false,
                      storageLocation: 'memory',
                      typeDescriptions: {
                        typeIdentifier: 't_string_memory_ptr',
                        typeString: 'string',
                      },
                      typeName: {
                        id: 50364,
                        name: 'string',
                        nodeType: 'ElementaryTypeName',
                        src: '4993:6:47',
                        typeDescriptions: {
                          typeIdentifier: 't_string_storage_ptr',
                          typeString: 'string',
                        },
                      },
                      visibility: 'internal',
                    },
                  ],
                  id: 50369,
                  initialValue: {
                    baseExpression: {
                      id: 50366,
                      name: '_wallets',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50019,
                      src: '5019:8:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_mapping$_t_address_$_t_string_storage_$',
                        typeString: 'mapping(address => string storage ref)',
                      },
                    },
                    id: 50368,
                    indexExpression: {
                      id: 50367,
                      name: 'wallet',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50358,
                      src: '5028:6:47',
                      typeDescriptions: {
                        typeIdentifier: 't_address',
                        typeString: 'address',
                      },
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: 'IndexAccess',
                    src: '5019:16:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage',
                      typeString: 'string storage ref',
                    },
                  },
                  nodeType: 'VariableDeclarationStatement',
                  src: '4993:42:47',
                },
                {
                  assignments: [50372],
                  declarations: [
                    {
                      constant: false,
                      id: 50372,
                      mutability: 'mutable',
                      name: 'accountUser',
                      nameLocation: '5065:11:47',
                      nodeType: 'VariableDeclaration',
                      scope: 50390,
                      src: '5045:31:47',
                      stateVariable: false,
                      storageLocation: 'storage',
                      typeDescriptions: {
                        typeIdentifier:
                          't_struct$_AccountUser_$50015_storage_ptr',
                        typeString: 'struct Verification.AccountUser',
                      },
                      typeName: {
                        id: 50371,
                        nodeType: 'UserDefinedTypeName',
                        pathNode: {
                          id: 50370,
                          name: 'AccountUser',
                          nameLocations: ['5045:11:47'],
                          nodeType: 'IdentifierPath',
                          referencedDeclaration: 50015,
                          src: '5045:11:47',
                        },
                        referencedDeclaration: 50015,
                        src: '5045:11:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_struct$_AccountUser_$50015_storage_ptr',
                          typeString: 'struct Verification.AccountUser',
                        },
                      },
                      visibility: 'internal',
                    },
                  ],
                  id: 50376,
                  initialValue: {
                    baseExpression: {
                      id: 50373,
                      name: '_accounts',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50024,
                      src: '5079:9:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_mapping$_t_string_memory_ptr_$_t_struct$_AccountUser_$50015_storage_$',
                        typeString:
                          'mapping(string memory => struct Verification.AccountUser storage ref)',
                      },
                    },
                    id: 50375,
                    indexExpression: {
                      id: 50374,
                      name: 'accountId',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50365,
                      src: '5089:9:47',
                      typeDescriptions: {
                        typeIdentifier: 't_string_memory_ptr',
                        typeString: 'string memory',
                      },
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: 'IndexAccess',
                    src: '5079:20:47',
                    typeDescriptions: {
                      typeIdentifier: 't_struct$_AccountUser_$50015_storage',
                      typeString: 'struct Verification.AccountUser storage ref',
                    },
                  },
                  nodeType: 'VariableDeclarationStatement',
                  src: '5045:54:47',
                },
                {
                  expression: {
                    id: 50386,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 50377,
                      name: 'accountUserView',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50362,
                      src: '5110:15:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_struct$_AccountUserView_$50356_memory_ptr',
                        typeString:
                          'struct Verification.AccountUserView memory',
                      },
                    },
                    nodeType: 'Assignment',
                    operator: '=',
                    rightHandSide: {
                      arguments: [
                        {
                          expression: {
                            id: 50379,
                            name: 'accountUser',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50372,
                            src: '5166:11:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_AccountUser_$50015_storage_ptr',
                              typeString:
                                'struct Verification.AccountUser storage pointer',
                            },
                          },
                          id: 50380,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '5178:6:47',
                          memberName: 'status',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 50010,
                          src: '5166:18:47',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        {
                          expression: {
                            id: 50381,
                            name: 'accountUser',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50372,
                            src: '5224:11:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_AccountUser_$50015_storage_ptr',
                              typeString:
                                'struct Verification.AccountUser storage pointer',
                            },
                          },
                          id: 50382,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '5236:24:47',
                          memberName: 'currentTotalTransactions',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 50012,
                          src: '5224:36:47',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                        {
                          expression: {
                            id: 50383,
                            name: 'accountUser',
                            nodeType: 'Identifier',
                            overloadedDeclarations: [],
                            referencedDeclaration: 50372,
                            src: '5291:11:47',
                            typeDescriptions: {
                              typeIdentifier:
                                't_struct$_AccountUser_$50015_storage_ptr',
                              typeString:
                                'struct Verification.AccountUser storage pointer',
                            },
                          },
                          id: 50384,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: '5303:15:47',
                          memberName: 'maxTransactions',
                          nodeType: 'MemberAccess',
                          referencedDeclaration: 50014,
                          src: '5291:27:47',
                          typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        },
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                          {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                          {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256',
                          },
                        ],
                        id: 50378,
                        name: 'AccountUserView',
                        nodeType: 'Identifier',
                        overloadedDeclarations: [],
                        referencedDeclaration: 50356,
                        src: '5128:15:47',
                        typeDescriptions: {
                          typeIdentifier:
                            't_type$_t_struct$_AccountUserView_$50356_storage_ptr_$',
                          typeString:
                            'type(struct Verification.AccountUserView storage pointer)',
                        },
                      },
                      id: 50385,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: 'structConstructorCall',
                      lValueRequested: false,
                      nameLocations: ['5158:6:47', '5198:24:47', '5274:15:47'],
                      names: [
                        'status',
                        'currentTotalTransactions',
                        'maxTransactions',
                      ],
                      nodeType: 'FunctionCall',
                      src: '5128:201:47',
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier:
                          't_struct$_AccountUserView_$50356_memory_ptr',
                        typeString:
                          'struct Verification.AccountUserView memory',
                      },
                    },
                    src: '5110:219:47',
                    typeDescriptions: {
                      typeIdentifier:
                        't_struct$_AccountUserView_$50356_memory_ptr',
                      typeString: 'struct Verification.AccountUserView memory',
                    },
                  },
                  id: 50387,
                  nodeType: 'ExpressionStatement',
                  src: '5110:219:47',
                },
                {
                  expression: {
                    id: 50388,
                    name: 'accountUserView',
                    nodeType: 'Identifier',
                    overloadedDeclarations: [],
                    referencedDeclaration: 50362,
                    src: '5347:15:47',
                    typeDescriptions: {
                      typeIdentifier:
                        't_struct$_AccountUserView_$50356_memory_ptr',
                      typeString: 'struct Verification.AccountUserView memory',
                    },
                  },
                  functionReturnParameters: 50363,
                  id: 50389,
                  nodeType: 'Return',
                  src: '5340:22:47',
                },
              ],
            },
            functionSelector: 'adeb320a',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'getAccountUserView',
            nameLocation: '4873:18:47',
            parameters: {
              id: 50359,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50358,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '4909:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50391,
                  src: '4901:14:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 50357,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '4901:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '4891:30:47',
            },
            returnParameters: {
              id: 50363,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50362,
                  mutability: 'mutable',
                  name: 'accountUserView',
                  nameLocation: '4966:15:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50391,
                  src: '4943:38:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier:
                      't_struct$_AccountUserView_$50356_memory_ptr',
                    typeString: 'struct Verification.AccountUserView',
                  },
                  typeName: {
                    id: 50361,
                    nodeType: 'UserDefinedTypeName',
                    pathNode: {
                      id: 50360,
                      name: 'AccountUserView',
                      nameLocations: ['4943:15:47'],
                      nodeType: 'IdentifierPath',
                      referencedDeclaration: 50356,
                      src: '4943:15:47',
                    },
                    referencedDeclaration: 50356,
                    src: '4943:15:47',
                    typeDescriptions: {
                      typeIdentifier:
                        't_struct$_AccountUserView_$50356_storage_ptr',
                      typeString: 'struct Verification.AccountUserView',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '4942:40:47',
            },
            scope: 50404,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
          {
            id: 50403,
            nodeType: 'FunctionDefinition',
            src: '5375:134:47',
            nodes: [],
            body: {
              id: 50402,
              nodeType: 'Block',
              src: '5469:40:47',
              nodes: [],
              statements: [
                {
                  expression: {
                    baseExpression: {
                      id: 50398,
                      name: '_wallets',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50019,
                      src: '5486:8:47',
                      typeDescriptions: {
                        typeIdentifier:
                          't_mapping$_t_address_$_t_string_storage_$',
                        typeString: 'mapping(address => string storage ref)',
                      },
                    },
                    id: 50400,
                    indexExpression: {
                      id: 50399,
                      name: 'wallet',
                      nodeType: 'Identifier',
                      overloadedDeclarations: [],
                      referencedDeclaration: 50393,
                      src: '5495:6:47',
                      typeDescriptions: {
                        typeIdentifier: 't_address',
                        typeString: 'address',
                      },
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: 'IndexAccess',
                    src: '5486:16:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage',
                      typeString: 'string storage ref',
                    },
                  },
                  functionReturnParameters: 50397,
                  id: 50401,
                  nodeType: 'Return',
                  src: '5479:23:47',
                },
              ],
            },
            functionSelector: 'd59ee5a9',
            implemented: true,
            kind: 'function',
            modifiers: [],
            name: 'getWalletAccountId',
            nameLocation: '5384:18:47',
            parameters: {
              id: 50394,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50393,
                  mutability: 'mutable',
                  name: 'wallet',
                  nameLocation: '5420:6:47',
                  nodeType: 'VariableDeclaration',
                  scope: 50403,
                  src: '5412:14:47',
                  stateVariable: false,
                  storageLocation: 'default',
                  typeDescriptions: {
                    typeIdentifier: 't_address',
                    typeString: 'address',
                  },
                  typeName: {
                    id: 50392,
                    name: 'address',
                    nodeType: 'ElementaryTypeName',
                    src: '5412:7:47',
                    stateMutability: 'nonpayable',
                    typeDescriptions: {
                      typeIdentifier: 't_address',
                      typeString: 'address',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '5402:30:47',
            },
            returnParameters: {
              id: 50397,
              nodeType: 'ParameterList',
              parameters: [
                {
                  constant: false,
                  id: 50396,
                  mutability: 'mutable',
                  name: '',
                  nameLocation: '-1:-1:-1',
                  nodeType: 'VariableDeclaration',
                  scope: 50403,
                  src: '5454:13:47',
                  stateVariable: false,
                  storageLocation: 'memory',
                  typeDescriptions: {
                    typeIdentifier: 't_string_memory_ptr',
                    typeString: 'string',
                  },
                  typeName: {
                    id: 50395,
                    name: 'string',
                    nodeType: 'ElementaryTypeName',
                    src: '5454:6:47',
                    typeDescriptions: {
                      typeIdentifier: 't_string_storage_ptr',
                      typeString: 'string',
                    },
                  },
                  visibility: 'internal',
                },
              ],
              src: '5453:15:47',
            },
            scope: 50404,
            stateMutability: 'view',
            virtual: false,
            visibility: 'public',
          },
        ],
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 49960,
              name: 'Ownable',
              nameLocations: ['224:7:47'],
              nodeType: 'IdentifierPath',
              referencedDeclaration: 43500,
              src: '224:7:47',
            },
            id: 49961,
            nodeType: 'InheritanceSpecifier',
            src: '224:7:47',
          },
          {
            baseName: {
              id: 49962,
              name: 'Pausable',
              nameLocations: ['233:8:47'],
              nodeType: 'IdentifierPath',
              referencedDeclaration: 43735,
              src: '233:8:47',
            },
            id: 49963,
            nodeType: 'InheritanceSpecifier',
            src: '233:8:47',
          },
        ],
        canonicalName: 'Verification',
        contractDependencies: [],
        contractKind: 'contract',
        fullyImplemented: true,
        linearizedBaseContracts: [50404, 43735, 43500, 45392],
        name: 'Verification',
        nameLocation: '208:12:47',
        scope: 50405,
        usedErrors: [],
        usedEvents: [43401, 43638, 43643, 49971, 49977, 49987, 49993],
      },
    ],
    license: 'MIT',
  },
  id: 47,
}
